import React, { useEffect } from "react";
import QRCode from "qrcode";
import { jsPDF } from "jspdf";
import { format, compareAsc } from "date-fns";
import Bunexe_service from "../../../Bunexe_service";

// import "./App.css";
import { useState } from "react";
import { toast } from "react-toastify";
//const jsPDF = require("jspdf");

const Ediplome = ({
  Info_personnelle,
  etapesuivante,
  etapeprecedente,
  methode_paiement,
  setMethode_paiement,
  montant_a_payer,
  date_trx,
  setDateTrx,
  id_trx,
  setIdTrx,
  valeurSelectionnee,
  setValeurSeclectionnee,
}) => {
  const [imageurl, setImageurl] = useState();
  const [matricule, setMatricule] = useState("");
  const [resultat, setResultat] = useState([]);
  const [name, setName] = useState("");
  const [les_documents, setLesDocuments] = useState("");

  // let les_documents = String(valeurSelectionnee)
  //   .toLowerCase()
  //   .replaceAll("_", " ");

  // console.log(les_documents);

  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  // const caps = str.split(' ').map(capitalize).join(' ');

  let url_ = Bunexe_service.url;

  const convertToDate = (dat_) => {
    return dat_ != "N/A"
      ? dat_.substring(8, 10) +
          "/" +
          dat_.substring(5, 7) +
          "/" +
          dat_.substring(0, 4)
      : "N/A";
  };
  /*const printReleve = (
    img_,
    identifiant,
    nom,
    prenom,
    annee,
    dnaiss_,
    lieu_,
    matricule,
    moy,
    section_,
    session_,
    Section_lib,
    sexe_,
    notes,
    TotCoef,
    Mois_lib,
  ) => {
    if (window.currentPdfUrl) {
      URL.revokeObjectURL(window.currentPdfUrl);
    }
    const doc = new jsPDF(); //, "mm", "letter");
    // Integrer l'image de fond dans le PDF
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    // const imgData = 'data:image/png;base64,...'; // Base64 image

    doc.addImage(
      "bordures/releve_armoirie_centree_v2.png",
      "PNG",
      0,
      0,
      pageWidth,
      pageHeight,
    );
    //doc.setFont("helvetica", "bold");
    doc.setFont("times", "bold");
    doc.setFontSize(14);
    //doc.setFont("helvetica", "bold");
    let Entete = "MINISTÈRE DE L’ÉDUCATION NATIONALE";
    let Entete2 = "ET DE LA FORMATION PROFESSIONNELLE";

    //doc.addImage("armoirie.jpeg", "jpeg", 86, 10, 30, 30);

    doc.text(Entete, 38, 44, { charSpace: "0.8" }, null, null, "center");
    doc.text(Entete2, 38, 52, { charSpace: "0.7" }, null, null, "center");

    doc.setFontSize(12);
    let dg = "DIRECTION GÉNÉRALE";
    doc.text(dg, 70, 62, { charSpace: "0.7" }, null, null, "center");
    doc.setFontSize(12);
    doc.setFont("times", "bold");

    //const aujourdhui = new Date();
    // const format = aujourdhui.toLocaleDateString("fr-FR", {
    //   day: "2-digit",
    //   month: "2-digit",
    //   year: "numeric",
    // });

    const aujourdHui = new Date();
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const dateFormatee = new Intl.DateTimeFormat("fr-FR", options).format(
      aujourdHui,
    );

    doc.setFont("helvetica", "italic");
    doc.text("Le " + dateFormatee, 176, 70, {
      charSpace: "0.7",
      align: "right",
    });
    //doc.text("Le " + format, 176, 70, { charSpace: "0.7", align: "right" });

    doc.setFontSize(12);
    doc.setFont("times", "bold");
    let releve = "RELEVÉ DE NOTES";
    doc.text(releve, 76, 76, { charSpace: "0.7" }, null, null, "center");

    doc.addImage(img_, "png", 18, 54, 25, 25);
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");

    let my_ch = "";

    let nom_ =
      nom.trim() + " " + prenom.trim().split(" ").map(capitalize).join(" ");
    doc.setFont("times", "normal");
    doc.setFontSize(12);
    let dnaiss = dnaiss_; //"15 Juillet 1978";
    let lieu = lieu_.trim(); //"Port-au-Prince";
    let sexe = sexe_ === "1" ? "Monsieur" : "Mademoiselle";

    let section = "";
    if (
      session_ == "T" ||
      session_ == "U" ||
      session_ == "V" ||
      session_ == "X"
    ) {
      //let s = Bunexe_service.serie.filter((s) => s.Code_serie == section_)[0];
      section = "UNIQUE, Secondaire IV à la série " + Section_lib;
    } else {
      section =
        "Secondaire, Section " + section_.substr(section_.length - 1, 1);
    }

    let dd1 = dnaiss_;
    let textbb1 = ` La Direction Générale du Ministère de l'Education Nationale et de la Formation Professionnelle`;
    let textbb2 = ` certifie que ${sexe} ${nom}`;
    let textbb3 = `${prenom
      .trim()
      .split(" ")
      .map(capitalize)
      .join(" ")} né(e) le ${dd1} à (au, aux) ${lieu},`;
    let textbb4 = `enregistré(e) au No. ${matricule}, a participé aux Examens `;
    textbb4 +=
      session_ == "T" || session_ == "U" || session_ == "V" || session_ == "X"
        ? "du BAC "
        : "de fin d'études ";
    let textbb5 = ` session de :`;
    let textbb6 = `${section} et a obtenu les notes suivantes pour la session de `;
    let splitTitle = doc.splitTextToSize(textbb6, 160);
    //let ligne2 = `a obtenu à la session de `; //${periode} ,le diplôme de fin d'études secondaires`;

    my_ch = textbb1 + " " + textbb2 + " " + textbb3 + " " + textbb4 + " ";
    // doc.text(textbb1, 15, 90, { charSpace: "0.7", align: "justify" });
    // doc.text(textbb2, 15, 96, { charSpace: "0.7", align: "justify" });
    // doc.text(textbb3, 15, 102, { charSpace: "0.7", align: "justify" });
    // doc.text(textbb4, 15, 108, { charSpace: "0.7", align: "justify" });

    let maSession = "";
    if (
      session_ == "T" ||
      session_ == "U" ||
      session_ == "V" ||
      session_ == "X"
    ) {
      // doc.text(`${section} et `, 15, 114, {
      //   charSpace: "0.7",
      //   align: "justify",
      // });
      // doc.text(
      //   `a obtenu les notes suivantes pour la session de `,
      //   15,
      //   120,
      //   { charSpace: "0.7" },
      //   "left"
      // );
      maSession = `${section} et a obtenu les notes suivantes pour la session de `;
    } else {
      maSession = `${textbb6}`;
      // doc.text(splitTitle, 15, 114, { charSpace: "0.7", align: "justify" });
    }

    my_ch += maSession;
    doc.setFont("times", "normal");
    doc.setFontSize(12);

    doc.setLineHeightFactor(1.5);
    doc.text(my_ch, 15, 82, {
      charSpace: "0.7",
      align: "justify",
      maxWidth: "126",
    });

    doc.setLineHeightFactor(1.15);
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    let peryod = "";

    if (Mois_lib.trim() === "Décembre" || Mois_lib.trim() === "Decembre") {
      peryod = " " + Mois_lib.trim() + " " + (parseInt(annee) - 1).toString();
    } else {
      peryod = " " + Mois_lib.trim() + " " + annee;
    }
    doc.setFontSize(16);
    //doc.text(peryod, 66, 134, { charSpace: "0.7", align: "justify" });
    doc.text(peryod, 76, 120, { charSpace: "0.7", align: "justify" });

    // if (annee == "2022") {
    //   peryod = " Février " + annee;
    //   doc.text(peryod, 66, 134, { charSpace: "0.7", align: "justify" });
    // } else {
    //   peryod = annee;
    //   doc.text(peryod, 90, 134, { charSpace: "0.7", align: "justify" });
    // }

    // my_ch += " " + peryod;

    // doc.text(my_ch, 15, 90, {
    //   charSpace: "0.7",
    //   align: "justify",
    //   maxWidth: 170,
    // });
    // doc.text(peryod, 90, 134, { charSpace: "0.7", align: "justify" });
    // doc.text(annee, 90, 134, { charSpace: "0.7", align: "justify" });
    doc.setFontSize(12);

    // let debut = 148;
    // let lineheight = 10;

    let debut = 130;
    let lineheight = 8;
    doc.setFont("helvetica", "bold");
    // doc.text("MATIÈRES", 48, 147, { charSpace: "0.7" });
    // doc.text("NOTES", 124, 147, { charSpace: "0.7" });

    doc.text("MATIÈRES", 48, 130, { charSpace: "0.7" });
    doc.text("NOTES", 124, 130, { charSpace: "0.7" });
    doc.setFont("times", "normal");
    let qteNotes = 0;
    // n.note.padStart(3, " ") + "   /   " + n.coef,
    notes.forEach((n) => {
      //if (n.matiere !== "" || n.matiere !== null) {
      if (
        n.coef !== "" &&
        n.note !== "" &&
        n.matiere !== "" &&
        n.note !== null &&
        n.matiere !== null
      ) {
        // console.log("Matiere : " + n.matiere);
        // console.log("Note : " + n.note);
        // console.log("Coef : " + n.coef);
        qteNotes += parseInt(n.note);
        debut += lineheight;
        doc.text(n.matiere, 48, debut, { charSpace: "0.7" });
        doc.text(
          n.note.padStart(3, " ") + "   /   " + n.coef,
          124,
          debut,
          { charSpace: "0.3" },
          "right",
        );
      }
    });

    doc.setFont("helvetica", "bold");
    doc.text(
      qteNotes.toString() + " sur " + TotCoef.toString(),
      100,
      256,
      null,
      null,
      "center",
    );

    let dir_bunexe = "Directeur";
    let bunexe = "Bureau National des Examens d'Etat";

    let certification_ = " Chef du Service";
    let certification__ = "de Certifiation et d'equivalence";

    doc.setFont("helvetica", "bold");
    doc.text(certification_, 40, 270, null, null, "center");
    doc.text(certification__, 40, 276, null, null, "center");

    // let dir_des = " Nesmy MANIGAT";
    // let des = " Ministre ";

    doc.setFont("helvetica", "bold");
    doc.text(dir_bunexe, 150, 270, null, null, "center");
    doc.text(bunexe, 150, 276, null, null, "center");

    // doc.text(certification_, 150, 270, null, null, "center");
    // doc.text(certification__, 150, 276, null, null, "center");
    //  doc.text(dir_bunexe, 40, 270, null, null, "center");
    // doc.text(bunexe, 40, 276, null, null, "center");

    doc.addImage("Elius-Louis.png", "png", 20, 258, 50, 15);
    //doc.addImage("signature-example.png", "png", 140, 242, 30, 10);
    doc.addImage("Signature_dirBunexe.png", "png", 128, 257, 50, 16);

    if (les_documents.includes("legalise seulement")) {
      doc.addImage("menfp_af.png", "png", 10, 210, 20, 20);
      doc.addImage("daj_menfp.png", "png", 10, 233, 40, 6);
    }
    // console.log("Valeur Selectionnee est :" + les_documents);
    if (les_documents.includes("legalise menfp mae")) {
      doc.addImage("menfp_af.png", "png", 10, 210, 20, 20);
      doc.addImage("daj_menfp.png", "png", 10, 233, 40, 6);

      doc.addImage("mae.jpeg", "jpeg", 170, 210, 20, 20);
      doc.addImage("daj_mae.png", "png", 170, 223, 30, 20);
    }
    if (window.screen.availWidth < 641) {
      document.getElementById("output").data = doc.output("datauristring");
      //doc.save(`bunexe_e_certificat-R-${identifiant}-${nom_}.pdf`);
    } else {
      //console.log(doc.output("datauristring"));
      //document.getElementById("output").data = doc.output("datauristring");
      //doc.save(`bunexe_e_certificat-R-${identifiant}-${nom_}.pdf`);

      const pdfBlob = doc.output("blob");
      const url = URL.createObjectURL(pdfBlob);
      document.getElementById("output").data = url; //URL.createObjectURL(pdfBlob);
      //document.getElementById("output").data = doc.output("datauristring");
      doc.save(`bunexe_e_certificat-R-${identifiant}-${nom_}.pdf`);
      window.currentPdfUrl = url;
    }
  };
  */

  /*
  const printReleve = (
    img_,
    identifiant,
    nom,
    prenom,
    annee,
    dnaiss_,
    lieu_,
    matricule,
    moy,
    section_,
    session_,
    Section_lib,
    sexe_,
    notes,
    TotCoef
  ) => {
    const doc = new jsPDF(); //, "mm", "letter");
    doc.setFont("helvetica", "bold");
    let Entete = "MINISTERE DE L'EDUCATION NATIONALE";
    let Entete2 = "ET DE LA FORMATION PROFESSIONNELLE";

    doc.addImage("armoirie.jpeg", "jpeg", 86, 10, 30, 30);

    doc.text(Entete, 38, 46, { charSpace: "0.8" });
    doc.text(Entete2, 38, 54, { charSpace: "0.7" });

    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    let releve = "RELEVÉ DE NOTES";
    doc.text(releve, 70, 68, { charSpace: "0.7" });

    doc.addImage(img_, "png", 150, 54, 30, 30);
    doc.setFontSize(30);
    doc.setFont("helvetica", "bold");

    let nom_ =
      nom.trim() + " " + prenom.trim().split(" ").map(capitalize).join(" ");
    doc.setFont("times", "normal");
    doc.setFontSize(12);
    let dnaiss = dnaiss_; //"15 Juillet 1978";
    let lieu = lieu_; //"Port-au-Prince";
    let sexe = sexe_ === "1" ? "Monsieur" : "Mademoiselle";

    let section = "";
    if (
      session_ == "T" ||
      session_ == "U" ||
      session_ == "V" ||
      session_ == "X"
    ) {
      //let s = Bunexe_service.serie.filter((s) => s.Code_serie == section_)[0];
      section = "UNIQUE, Secondaire IV à la série " + Section_lib;
    } else {
      section =
        "Secondaire, Section " + section_.substr(section_.length - 1, 1);
    }

    let dd1 = dnaiss_;
    let textbb1 = ` Le Ministère de l'Education Nationale et de la Formation Professionnelle`;
    let textbb2 = ` ( M.E.N.F.P ) certifie que ${sexe} ${nom}`;
    let textbb3 = `${prenom
      .trim()
      .split(" ")
      .map(capitalize)
      .join(" ")} né(e) le ${dd1} à (au, aux) ${lieu},`;
    let textbb4 = `enregistré(e) au No. ${matricule}, a participé aux Examens `;
    textbb4 +=
      session_ == "T" || session_ == "U" || session_ == "V" || session_ == "X"
        ? "du BAC "
        : "de fin d'études ";
    let textbb5 = ` session de :`;
    let textbb6 = `${section} et a obtenu les notes suivantes pour la session de `;
    let splitTitle = doc.splitTextToSize(textbb6, 160);
    //let ligne2 = `a obtenu à la session de `; //${periode} ,le diplôme de fin d'études secondaires`;
    doc.text(textbb1, 15, 90, { charSpace: "0.7", align: "justify" });
    doc.text(textbb2, 15, 96, { charSpace: "0.7", align: "justify" });
    doc.text(textbb3, 15, 102, { charSpace: "0.7", align: "justify" });
    doc.text(textbb4, 15, 108, { charSpace: "0.7", align: "justify" });

    let maSession = "";
    if (
      session_ == "T" ||
      session_ == "U" ||
      session_ == "V" ||
      session_ == "X"
    ) {
      doc.text(`${section} et `, 15, 114, {
        charSpace: "0.7",
        align: "justify",
      });
      doc.text(
        `a obtenu les notes suivantes pour la session de `,
        15,
        120,
        { charSpace: "0.7" },
        "left"
      );
      maSession = `${section} et a obtenu les notes suivantes pour la session de `;
    } else {
      maSession = `${textbb6}`;
      doc.text(splitTitle, 15, 114, { charSpace: "0.7", align: "justify" });
    }

    doc.setFontSize(26);
    doc.setFont("helvetica", "bold");
    let peryod = "";
    if (annee == "2022") {
      peryod = " Février " + annee;
      doc.text(peryod, 66, 134, { charSpace: "0.7", align: "justify" });
    } else {
      peryod = annee;
      doc.text(peryod, 90, 134, { charSpace: "0.7", align: "justify" });
    }
    // doc.text(peryod, 90, 134, { charSpace: "0.7", align: "justify" });
    // doc.text(annee, 90, 134, { charSpace: "0.7", align: "justify" });
    doc.setFontSize(12);

    let debut = 146;
    let lineheight = 10;
    doc.setFont("helvetica", "bold");
    doc.text("MATIÈRES", 44, 144, { charSpace: "0.7" });
    doc.text("NOTES", 120, 144, { charSpace: "0.7" });
    doc.setFont("times", "normal");
    let qteNotes = 0;
    // n.note.padStart(3, " ") + "   /   " + n.coef,
    notes.forEach((n) => {
      if (n.matiere !== "") {
        qteNotes += parseInt(n.note);
        debut += lineheight;
        doc.text(n.matiere, 44, debut, { charSpace: "0.7" });
        doc.text(
          n.note.padStart(3, " ") + "   /   " + n.coef,
          120,
          debut,
          { charSpace: "0.3" },
          "right"
        );
      }
    });

    doc.setFont("helvetica", "bold");
    doc.text(
      qteNotes.toString() + " sur " + TotCoef.toString(),
      100,
      256,
      null,
      null,
      "center"
    );

    let dir_bunexe = "Le Directeur du Bureau";
    let bunexe = "National des Examens d'Etat";
    doc.setFont("helvetica", "bold");
    doc.text(dir_bunexe, 40, 270, null, null, "center");
    doc.text(bunexe, 40, 276, null, null, "center");

    // let dir_des = " Nesmy MANIGAT";
    // let des = " Ministre ";

    let dir_des = " Le Ministre";
    //let des = " Ministre ";
    doc.setFont("helvetica", "bold");
    doc.text(dir_des, 150, 270, null, null, "center");

    doc.addImage("DirBUNEXE_Renan.jpg", "jpg", 30, 252, 50, 15);
    //doc.addImage("signature-example.png", "png", 140, 242, 30, 10);
    doc.addImage("Ministre.jpg", "jpg", 140, 252, 30, 10);

    doc.addImage("menfp_af.png", "png", 10, 210, 20, 20);
    doc.addImage("daj_menfp.png", "png", 10, 233, 40, 6);

    doc.addImage("mae.jpeg", "jpeg", 170, 210, 20, 20);
    doc.addImage("daj_mae.png", "png", 170, 223, 30, 20);

    if (window.screen.availWidth < 641) {
      document.getElementById("output").data = doc.output("datauristring");
      //doc.save(`bunexe_e_certificat-R-${identifiant}-${nom_}.pdf`);
    } else {
      //console.log(doc.output("datauristring"));
      document.getElementById("output").data = doc.output("datauristring");
      doc.save(`bunexe_e_certificat-R-${identifiant}-${nom_}.pdf`);
    }
  };
  */
  const printReleve1 = (
    img_,
    identifiant,
    nom,
    prenom,
    annee,
    dnaiss_,
    lieu_,
    matricule,
    moy,
    section_,
    session_,
    Section_lib,
    sexe_,
    notes,
    TotCoef,
    Mois_lib,
  ) => {
    if (window.currentPdfUrl) {
      URL.revokeObjectURL(window.currentPdfUrl);
    }

    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // ==================== FOND ====================
    doc.addImage(
      "bordures/releve_armoirie_centree_v2.png",
      "PNG",
      0,
      0,
      pageWidth,
      pageHeight,
    );

    // ==================== FONCTIONS UTILITAIRES ====================
    const capitalize = (str) => {
      if (!str) return "";
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };

    // ==================== ENTÊTE ====================
    doc.setFont("times", "bold");
    doc.setFontSize(14);

    doc.text("MINISTÈRE DE L'ÉDUCATION NATIONALE", 105, 44, {
      charSpace: "0.5",
      align: "center",
    });
    doc.text("ET DE LA FORMATION PROFESSIONNELLE", 105, 52, {
      charSpace: "0.5",
      align: "center",
    });

    doc.setFontSize(12);
    doc.text("DIRECTION GÉNÉRALE", 105, 62, {
      charSpace: "0.5",
      align: "center",
    });

    // ==================== DATE ====================
    const aujourdHui = new Date();
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const dateFormatee = new Intl.DateTimeFormat("fr-FR", options).format(
      aujourdHui,
    );

    doc.setFont("times", "italic");
    doc.setFontSize(10);
    doc.text("Le " + dateFormatee, 180, 70, {
      charSpace: "0.3",
      align: "right",
    });

    // ==================== TITRE RELEVÉ ====================
    doc.setFont("times", "bold");
    doc.setFontSize(16);
    doc.text("RELEVÉ DE NOTES", 105, 80, {
      charSpace: "0.7",
      align: "center",
    });

    // ==================== IMAGE ====================
    doc.addImage(img_, "png", 18, 54, 25, 25);

    // ==================== PRÉPARATION DES DONNÉES ====================
    const sexe = sexe_ === "1" ? "Monsieur" : "Mademoiselle";
    const nomPrenom = `${nom.trim()} ${prenom.trim().split(" ").map(capitalize).join(" ")}`;
    const dateNaissance = dnaiss_;
    const lieu = lieu_.trim();
    const numeroMatricule = matricule;

    // Déterminer le type d'examen et la section
    let typeExamen = "";
    let section = "";
    if (
      session_ === "T" ||
      session_ === "U" ||
      session_ === "V" ||
      session_ === "X"
    ) {
      typeExamen = "du BAC UNIQUE, Secondaire IV à la série ";
      section = `${Section_lib}`;
    } else {
      typeExamen = "de fin d'études Secondaire, ";
      section = ` Section ${section_.substr(section_.length - 1, 1)}`;
    }

    // Déterminer la session
    const peryod =
      Mois_lib.trim() === "Décembre" || Mois_lib.trim() === "Decembre"
        ? `${Mois_lib.trim()} ${parseInt(annee) - 1}`
        : `${Mois_lib.trim()} ${annee}`;

    // ==================== TEXTE PRINCIPAL - SOLUTION CORRECTE ====================
    const yStart = 92;
    const xStart = 20;
    const maxWidth = 172;
    const fontSize = 10.5;
    const charSpace = "0.3";

    // Définir les segments avec des espaces INCLUS dans le texte
    // IMPORTANT: Chaque segment doit contenir ses espaces
    const segments = [
      {
        text: "La Direction Générale du Ministère de l'Éducation Nationale et de la Formation Professionnelle certifie ",
        bold: false,
      },
      { text: sexe + " " + nomPrenom + " ", bold: true }, // ESPACE APRES LE NOM
      { text: "né(e) le   ", bold: false },
      { text: dateNaissance + " ", bold: true }, // ESPACE APRES LA DATE
      {
        text: "  à (au, aux) " + lieu + ", enregistré(e) au No. ",
        bold: false,
      },
      { text: numeroMatricule + " ", bold: true }, // ESPACE APRES LE MATRICULE
      { text: ", a participé aux Examens " + typeExamen, bold: false },
      { text: " " + section + " ", bold: true }, // ESPACE APRES LA SERIE
      {
        text: "et a obtenu les notes suivantes pour la session de ",
        bold: false,
      },
    ];

    // Fonction SIMPLIFIÉE pour écrire le texte
    function writeTextWithBold(
      doc,
      segments,
      x,
      y,
      fontSize,
      charSpace,
      maxWidth,
    ) {
      let currentX = x;
      let currentY = y;
      let lineWidth = 0;
      let currentSegments = [];
      const lineHeight = 7;

      // Calculer les largeurs
      const segsWithWidth = segments.map((seg) => {
        doc.setFont("times", seg.bold ? "bold" : "normal");
        doc.setFontSize(fontSize);
        const width = doc.getTextWidth(seg.text);
        return { ...seg, width };
      });

      // Écrire segment par segment
      for (let i = 0; i < segsWithWidth.length; i++) {
        const seg = segsWithWidth[i];

        // Si le segment seul est trop long, le couper
        if (seg.width > maxWidth) {
          // Écrire la ligne courante
          if (currentSegments.length > 0) {
            let xPos = x;
            currentSegments.forEach((s) => {
              doc.setFont("times", s.bold ? "bold" : "normal");
              doc.setFontSize(fontSize);
              doc.text(s.text, xPos, currentY, { charSpace });
              xPos += s.width;
            });
            currentY += lineHeight;
            currentSegments = [];
            lineWidth = 0;
          }

          // Couper le segment long en mots
          const words = seg.text.split(" ");
          let tempText = "";
          let tempWidth = 0;

          for (let j = 0; j < words.length; j++) {
            const testText = tempText + (j > 0 ? " " : "") + words[j];
            doc.setFont("times", seg.bold ? "bold" : "normal");
            doc.setFontSize(fontSize);
            const testWidth = doc.getTextWidth(testText);

            if (testWidth <= maxWidth) {
              tempText = testText;
              tempWidth = testWidth;
            } else {
              if (tempText) {
                doc.setFont("times", seg.bold ? "bold" : "normal");
                doc.setFontSize(fontSize);
                doc.text(tempText, x, currentY, { charSpace });
                currentY += lineHeight;
              }
              tempText = words[j];
              tempWidth = doc.getTextWidth(words[j]);
            }
          }

          if (tempText) {
            doc.setFont("times", seg.bold ? "bold" : "normal");
            doc.setFontSize(fontSize);
            doc.text(tempText, x, currentY, { charSpace });
            currentY += lineHeight;
          }
          continue;
        }

        // Vérifier si le segment tient dans la ligne
        if (lineWidth + seg.width <= maxWidth) {
          currentSegments.push(seg);
          lineWidth += seg.width;
        } else {
          // Écrire la ligne courante
          if (currentSegments.length > 0) {
            let xPos = x;
            currentSegments.forEach((s) => {
              doc.setFont("times", s.bold ? "bold" : "normal");
              doc.setFontSize(fontSize);
              doc.text(s.text, xPos, currentY, { charSpace });
              xPos += s.width;
            });
            currentY += lineHeight;
          }

          // Commencer une nouvelle ligne avec ce segment
          currentSegments = [seg];
          lineWidth = seg.width;
        }
      }

      // Écrire la dernière ligne
      if (currentSegments.length > 0) {
        let xPos = x;
        currentSegments.forEach((s) => {
          doc.setFont("times", s.bold ? "bold" : "normal");
          doc.setFontSize(fontSize);
          doc.text(s.text, xPos, currentY, { charSpace });
          xPos += s.width;
        });
        currentY += lineHeight;
      }

      return currentY;
    }

    // Écrire le texte
    let currentYPosition = writeTextWithBold(
      doc,
      segments,
      xStart,
      yStart,
      fontSize,
      charSpace,
      maxWidth,
    );

    // ==================== SESSION ====================
    doc.setFont("times", "bold");
    doc.setFontSize(12);
    doc.text(peryod, 105, currentYPosition + 5, {
      charSpace: "0.5",
      align: "center",
    });
    currentYPosition += 18;

    // ==================== TABLEAU DES NOTES ====================
    const tableX = 35;
    const tableY = currentYPosition;
    const col1X = 45;
    const col2X = 135;
    const col3X = 160;

    // Ligne de séparation
    doc.setDrawColor(0);
    doc.setLineWidth(0.5);
    doc.line(tableX, tableY - 2, tableX + 150, tableY - 2);

    doc.setFont("times", "bold");
    doc.setFontSize(11);
    doc.text("MATIÈRES", col1X, tableY + 4, { charSpace: "0.5" });
    doc.text("NOTES", col2X, tableY + 4, { charSpace: "0.5" });

    doc.line(tableX, tableY + 6, tableX + 150, tableY + 6);

    let rowY = tableY + 12;
    let qteNotes = 0;

    // Affichage des notes
    doc.setFont("times", "normal");
    doc.setFontSize(10);

    notes.forEach((n, index) => {
      if (
        n.coef !== "" &&
        n.note !== "" &&
        n.matiere !== "" &&
        n.note !== null &&
        n.matiere !== null
      ) {
        qteNotes += parseInt(n.note) || 0;

        if (index % 2 === 0) {
          doc.setFillColor(240, 240, 240);
          doc.rect(tableX, rowY - 3, 150, 7, "F");
        }

        doc.text(n.matiere, col1X, rowY + 1, { charSpace: "0.3" });
        doc.text(
          n.note.padStart(3, " ") + "   /   " + n.coef,
          col2X,
          rowY + 1,
          {
            charSpace: "0.2",
            align: "right",
          },
        );

        rowY += 7;
      }
    });

    doc.line(tableX, rowY + 2, tableX + 150, rowY + 2);

    // ==================== TOTAL ====================
    const totalY = rowY + 15;
    doc.setFont("times", "bold");
    doc.setFontSize(13);
    doc.text(`${qteNotes} sur ${TotCoef}`, 105, totalY, {
      charSpace: "0.5",
      align: "center",
    });

    // ==================== SIGNATURES ====================
    const signatureY = 265;

    doc.setFont("times", "bold");
    doc.setFontSize(10);

    doc.text("Chef du Service", 55, signatureY, { align: "center" });
    doc.text("de Certification et d'équivalence", 55, signatureY + 6, {
      align: "center",
    });

    doc.text("Directeur", 155, signatureY, { align: "center" });
    doc.text("Bureau National des Examens d'Etat", 155, signatureY + 6, {
      align: "center",
    });

    // ==================== IMAGES DE SIGNATURE ====================
    doc.addImage("Elius-Louis.png", "png", 30, 250, 50, 15);
    doc.addImage("Signature_dirBunexe.png", "png", 130, 249, 50, 16);

    // ==================== IMAGES SUPPLÉMENTAIRES ====================
    if (typeof les_documents !== "undefined" && les_documents) {
      if (les_documents.includes("legalise seulement")) {
        doc.addImage("menfp_af.png", "png", 10, 210, 20, 20);
        doc.addImage("daj_menfp.png", "png", 10, 233, 40, 6);
      }
      if (les_documents.includes("legalise menfp mae")) {
        doc.addImage("menfp_af.png", "png", 10, 210, 20, 20);
        doc.addImage("daj_menfp.png", "png", 10, 233, 40, 6);
        doc.addImage("mae.jpeg", "jpeg", 170, 210, 20, 20);
        doc.addImage("daj_mae.png", "png", 170, 223, 30, 20);
      }
    }

    // ==================== SAUVEGARDE ====================
    const nomFichier = `bunexe_e_certificat-R-${identifiant}-${nom.trim()}_${prenom.trim()}.pdf`;

    if (window.screen.availWidth < 641) {
      document.getElementById("output").data = doc.output("datauristring");
    } else {
      const pdfBlob = doc.output("blob");
      const url = URL.createObjectURL(pdfBlob);
      document.getElementById("output").data = url;
      doc.save(nomFichier);
      window.currentPdfUrl = url;
    }
  };

  const printReleve2 = (
    img_,
    identifiant,
    nom,
    prenom,
    annee,
    dnaiss_,
    lieu_,
    matricule,
    moy,
    section_,
    session_,
    Section_lib,
    sexe_,
    notes,
    TotCoef,
    Mois_lib,
  ) => {
    if (window.currentPdfUrl) {
      URL.revokeObjectURL(window.currentPdfUrl);
    }

    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // ==================== FOND ====================
    doc.addImage(
      "bordures/releve_armoirie_centree_v2.png",
      "PNG",
      0,
      0,
      pageWidth,
      pageHeight,
    );

    // ==================== FONCTIONS UTILITAIRES ====================
    const capitalize = (str) => {
      if (!str) return "";
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };

    // ==================== FONCTION DE JUSTIFICATION ====================
    function justifyText(
      doc,
      segments,
      x,
      y,
      maxWidth,
      fontSize,
      lineHeight = 7,
    ) {
      let currentX = x;
      let currentY = y;
      let lineSegments = [];
      let lineWidth = 0;
      let allLines = [];
      let currentLine = [];

      // Calculer les largeurs de tous les segments
      const segsWithWidth = segments.map((seg) => {
        doc.setFont("times", seg.bold ? "bold" : "normal");
        doc.setFontSize(fontSize);
        const width = doc.getTextWidth(seg.text);
        return { ...seg, width };
      });

      // Découper en lignes
      for (let i = 0; i < segsWithWidth.length; i++) {
        const seg = segsWithWidth[i];

        // Si le segment seul dépasse la largeur max, on le coupe
        if (seg.width > maxWidth) {
          // Sauvegarder la ligne courante
          if (currentLine.length > 0) {
            allLines.push([...currentLine]);
            currentLine = [];
            lineWidth = 0;
          }

          // Couper le segment long
          const words = seg.text.split(" ");
          let tempText = "";
          let tempSegments = [];

          for (let j = 0; j < words.length; j++) {
            const testText = tempText + (j > 0 ? " " : "") + words[j];
            doc.setFont("times", seg.bold ? "bold" : "normal");
            doc.setFontSize(fontSize);
            const testWidth = doc.getTextWidth(testText);

            if (testWidth <= maxWidth) {
              tempText = testText;
            } else {
              if (tempText) {
                allLines.push([
                  { ...seg, text: tempText, width: doc.getTextWidth(tempText) },
                ]);
              }
              tempText = words[j];
            }
          }

          if (tempText) {
            allLines.push([
              { ...seg, text: tempText, width: doc.getTextWidth(tempText) },
            ]);
          }
          continue;
        }

        // Vérifier si le segment tient dans la ligne courante
        if (lineWidth + seg.width <= maxWidth) {
          currentLine.push(seg);
          lineWidth += seg.width;
        } else {
          // Sauvegarder la ligne courante
          if (currentLine.length > 0) {
            allLines.push([...currentLine]);
          }
          // Commencer une nouvelle ligne
          currentLine = [seg];
          lineWidth = seg.width;
        }
      }

      // Ajouter la dernière ligne
      if (currentLine.length > 0) {
        allLines.push([...currentLine]);
      }

      // ==================== ÉCRIRE LES LIGNES JUSTIFIÉES ====================
      allLines.forEach((line, lineIndex) => {
        const totalWidth = line.reduce((sum, seg) => sum + seg.width, 0);
        const isLastLine = lineIndex === allLines.length - 1;

        // Calculer l'espacement supplémentaire pour la justification
        let extraSpace = 0;
        let spaceCount = line.length - 1;

        // Ne justifier que si ce n'est pas la dernière ligne et qu'il y a plus d'un segment
        if (!isLastLine && spaceCount > 0 && totalWidth < maxWidth) {
          extraSpace = (maxWidth - totalWidth) / spaceCount;
        }

        let xPos = x;

        line.forEach((seg, segIndex) => {
          doc.setFont("times", seg.bold ? "bold" : "normal");
          doc.setFontSize(fontSize);
          doc.text(seg.text, xPos, currentY, { charSpace: "0.2" });
          xPos += seg.width;

          // Ajouter l'espace supplémentaire pour la justification
          if (segIndex < line.length - 1 && !isLastLine) {
            xPos += extraSpace;
          }
        });

        currentY += lineHeight;
      });

      return currentY;
    }

    // ==================== ENTÊTE ====================
    doc.setFont("times", "bold");
    doc.setFontSize(14);

    doc.text("MINISTÈRE DE L'ÉDUCATION NATIONALE", 105, 44, {
      charSpace: "0.5",
      align: "center",
    });
    doc.text("ET DE LA FORMATION PROFESSIONNELLE", 105, 52, {
      charSpace: "0.5",
      align: "center",
    });

    doc.setFontSize(12);
    doc.text("DIRECTION GÉNÉRALE", 105, 62, {
      charSpace: "0.5",
      align: "center",
    });

    // ==================== DATE ====================
    const aujourdHui = new Date();
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const dateFormatee = new Intl.DateTimeFormat("fr-FR", options).format(
      aujourdHui,
    );

    doc.setFont("times", "italic");
    doc.setFontSize(10);
    doc.text("Le " + dateFormatee, 180, 70, {
      charSpace: "0.3",
      align: "right",
    });

    // ==================== TITRE RELEVÉ ====================
    doc.setFont("times", "bold");
    doc.setFontSize(16);
    doc.text("RELEVÉ DE NOTES", 105, 80, {
      charSpace: "0.7",
      align: "center",
    });

    // ==================== IMAGE ====================
    doc.addImage(img_, "png", 18, 54, 25, 25);

    // ==================== PRÉPARATION DES DONNÉES ====================
    const sexe = sexe_ === "1" ? "Monsieur" : "Mademoiselle";
    const nomPrenom = `${nom.trim()} ${prenom.trim().split(" ").map(capitalize).join(" ")}`;
    const dateNaissance = dnaiss_;
    const lieu = lieu_.trim();
    const numeroMatricule = matricule;

    // Déterminer le type d'examen et la section
    let typeExamen = "";
    let section = "";
    if (
      session_ === "T" ||
      session_ === "U" ||
      session_ === "V" ||
      session_ === "X"
    ) {
      typeExamen = "du BAC ";
      section = `UNIQUE, Secondaire IV à la série ${Section_lib}`;
    } else {
      typeExamen = "de fin d'études ";
      section = `Secondaire, Section ${section_.substr(section_.length - 1, 1)}`;
    }

    // Déterminer la session
    const peryod =
      Mois_lib.trim() === "Décembre" || Mois_lib.trim() === "Decembre"
        ? `${Mois_lib.trim()} ${parseInt(annee) - 1}`
        : `${Mois_lib.trim()} ${annee}`;

    // ==================== TEXTE PRINCIPAL AVEC JUSTIFICATION ====================
    const xStart = 20;
    const yStart = 92;
    const maxWidth = 175;
    const fontSize = 10.5;

    // Construction des segments pour une justification parfaite
    const segments = [
      {
        text: "La Direction Générale du Ministère de l'Éducation Nationale et de la Formation Professionnelle certifie ",
        bold: false,
      },
      { text: sexe + " " + nomPrenom + " ", bold: true },
      { text: "né(e) le ", bold: false },
      { text: dateNaissance + " ", bold: true },
      { text: "à (au, aux) " + lieu + ", enregistré(e) au No. ", bold: false },
      { text: numeroMatricule + " ", bold: true },
      { text: ", a participé aux Examens " + typeExamen, bold: false },
      { text: section + " ", bold: true },
      {
        text: "et a obtenu les notes suivantes pour la session de ",
        bold: false,
      },
    ];

    // Appliquer la justification
    let currentY = justifyText(
      doc,
      segments,
      xStart,
      yStart,
      maxWidth,
      fontSize,
      7.5, // Hauteur de ligne légèrement augmentée pour la lisibilité
    );

    // ==================== SESSION ====================
    doc.setFont("times", "bold");
    doc.setFontSize(12);
    doc.text(peryod, 105, currentY + 5, {
      charSpace: "0.5",
      align: "center",
    });
    currentY += 18;

    // ==================== TABLEAU DES NOTES ====================
    const tableX = 35;
    const tableY = currentY;
    const col1X = 45;
    const col2X = 135;
    const col3X = 160;

    // Ligne de séparation
    doc.setDrawColor(0);
    doc.setLineWidth(0.5);
    doc.line(tableX, tableY - 2, tableX + 150, tableY - 2);

    doc.setFont("times", "bold");
    doc.setFontSize(11);
    doc.text("MATIÈRES", col1X, tableY + 4, { charSpace: "0.5" });
    doc.text("NOTES", col2X, tableY + 4, { charSpace: "0.5" });

    doc.line(tableX, tableY + 6, tableX + 150, tableY + 6);

    let rowY = tableY + 12;
    let qteNotes = 0;

    // Affichage des notes
    doc.setFont("times", "normal");
    doc.setFontSize(10);

    notes.forEach((n, index) => {
      if (
        n.coef !== "" &&
        n.note !== "" &&
        n.matiere !== "" &&
        n.note !== null &&
        n.matiere !== null
      ) {
        qteNotes += parseInt(n.note) || 0;

        if (index % 2 === 0) {
          doc.setFillColor(240, 240, 240);
          doc.rect(tableX, rowY - 3, 150, 7, "F");
        }

        doc.text(n.matiere, col1X, rowY + 1, { charSpace: "0.3" });
        doc.text(
          n.note.padStart(3, " ") + "   /   " + n.coef,
          col2X,
          rowY + 1,
          {
            charSpace: "0.2",
            align: "right",
          },
        );

        rowY += 7;
      }
    });

    doc.line(tableX, rowY + 2, tableX + 150, rowY + 2);

    // ==================== TOTAL ====================
    const totalY = rowY + 15;
    doc.setFont("times", "bold");
    doc.setFontSize(13);
    doc.text(`${qteNotes} sur ${TotCoef}`, 105, totalY, {
      charSpace: "0.5",
      align: "center",
    });

    // ==================== SIGNATURES ====================
    const signatureY = 265;

    doc.setFont("times", "bold");
    doc.setFontSize(10);

    doc.text("Chef du Service", 55, signatureY, { align: "center" });
    doc.text("de Certification et d'équivalence", 55, signatureY + 6, {
      align: "center",
    });

    doc.text("Directeur", 155, signatureY, { align: "center" });
    doc.text("Bureau National des Examens d'Etat", 155, signatureY + 6, {
      align: "center",
    });

    // ==================== IMAGES DE SIGNATURE ====================
    doc.addImage("Elius-Louis.png", "png", 30, 250, 50, 15);
    doc.addImage("Signature_dirBunexe.png", "png", 130, 249, 50, 16);

    // ==================== IMAGES SUPPLÉMENTAIRES ====================
    if (typeof les_documents !== "undefined" && les_documents) {
      if (les_documents.includes("legalise seulement")) {
        doc.addImage("menfp_af.png", "png", 10, 210, 20, 20);
        doc.addImage("daj_menfp.png", "png", 10, 233, 40, 6);
      }
      if (les_documents.includes("legalise menfp mae")) {
        doc.addImage("menfp_af.png", "png", 10, 210, 20, 20);
        doc.addImage("daj_menfp.png", "png", 10, 233, 40, 6);
        doc.addImage("mae.jpeg", "jpeg", 170, 210, 20, 20);
        doc.addImage("daj_mae.png", "png", 170, 223, 30, 20);
      }
    }

    // ==================== SAUVEGARDE ====================
    const nomFichier = `bunexe_e_certificat-R-${identifiant}-${nom.trim()}_${prenom.trim()}.pdf`;

    if (window.screen.availWidth < 641) {
      document.getElementById("output").data = doc.output("datauristring");
    } else {
      const pdfBlob = doc.output("blob");
      const url = URL.createObjectURL(pdfBlob);
      document.getElementById("output").data = url;
      doc.save(nomFichier);
      window.currentPdfUrl = url;
    }
  };

  const printReleve3 = (
    img_,
    identifiant,
    nom,
    prenom,
    annee,
    dnaiss_,
    lieu_,
    matricule,
    moy,
    section_,
    session_,
    Section_lib,
    sexe_,
    notes,
    TotCoef,
    Mois_lib,
  ) => {
    if (window.currentPdfUrl) {
      URL.revokeObjectURL(window.currentPdfUrl);
    }
    const doc = new jsPDF(); //, "mm", "letter");

    // Integrer l'image de fond dans le PDF
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    doc.addImage(
      "bordures/releve_armoirie_centree_v2.png",
      "PNG",
      0,
      0,
      pageWidth,
      pageHeight,
    );

    doc.setFont("times", "bold");
    doc.setFontSize(14);

    let Entete = "MINISTÈRE DE L’ÉDUCATION NATIONALE";
    let Entete2 = "ET DE LA FORMATION PROFESSIONNELLE";

    doc.text(Entete, 38, 44, { charSpace: "0.8" }, null, null, "center");
    doc.text(Entete2, 38, 52, { charSpace: "0.7" }, null, null, "center");

    doc.setFontSize(12);
    let dg = "DIRECTION GÉNÉRALE";
    doc.text(dg, 70, 62, { charSpace: "0.7" }, null, null, "center");
    doc.setFontSize(12);
    doc.setFont("times", "bold");

    const aujourdHui = new Date();
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const dateFormatee = new Intl.DateTimeFormat("fr-FR", options).format(
      aujourdHui,
    );

    doc.setFont("helvetica", "italic");
    doc.text("Le " + dateFormatee, 176, 70, {
      charSpace: "0.7",
      align: "right",
    });

    doc.setFontSize(12);
    doc.setFont("times", "bold");
    let releve = "RELEVÉ DE NOTES";
    doc.text(releve, 76, 76, { charSpace: "0.7" }, null, null, "center");

    doc.addImage(img_, "png", 18, 54, 25, 25);
    doc.setFontSize(12);

    // --- PRÉPARATION DES VARIABLES ---
    let nomComplet =
      nom.trim() + " " + prenom.trim().split(" ").map(capitalize).join(" ");
    let lieu = lieu_.trim();
    let sexe = sexe_ === "1" ? "Monsieur" : "Mademoiselle";

    let section = "";
    if (["T", "U", "V", "X"].includes(session_)) {
      section = "UNIQUE, Secondaire IV à la série " + Section_lib;
    } else {
      section =
        "Secondaire, Section " + section_.substr(section_.length - 1, 1);
    }

    let typeExam = ["T", "U", "V", "X"].includes(session_)
      ? "du BAC "
      : "de fin d'études ";

    // --- IMPRESSION DU TEXTE EN FORMAT MIXTE (NORMAL / BOLD) ---
    doc.setFont("times", "normal");
    doc.setLineHeightFactor(1.5);

    // Coordonnées de départ pour le bloc de texte
    let startX = 15;
    let startY = 82;
    let currentX = startX;
    let currentY = startY;
    const maxWidth = 180; // Largeur maximale augmentée pour une meilleure occupation de l'espace (A4 fait 210mm)
    const spaceWidth = doc.getTextWidth(" ");

    // Définition des segments de texte avec leur style respectif
    const fragments = [
      {
        text: "La Direction Générale du Ministère de l'Education Nationale et de la Formation Professionnelle certifie que ",
        style: "normal",
      },
      { text: `${sexe} ${nomComplet} `, style: "bold" },
      { text: "né(e) le ", style: "normal" },
      { text: `${dnaiss_} `, style: "bold" },
      { text: `à (au, aux) ${lieu}, enregistré(e) au No. `, style: "normal" },
      { text: `${matricule}, `, style: "bold" },
      { text: `a participé aux Examens ${typeExam}`, style: "normal" },
      { text: `${section} `, style: "bold" },
      {
        text: "et a obtenu les notes suivantes pour la session de :",
        style: "normal",
      },
    ];

    // Boucle intelligente pour écrire le texte mot par mot en gérant le retour à la ligne et le gras
    fragments.forEach((frag) => {
      doc.setFont("times", frag.style);
      const words = frag.text.split(/(\s+)/); // Découpe en gardant les espaces

      words.forEach((word) => {
        if (!word) return;

        const wordWidth = doc.getTextWidth(word);

        // Si le mot dépasse la largeur max disponible, on passe à la ligne suivante
        if (currentX + wordWidth > maxWidth + startX) {
          currentX = startX;
          currentY += 7; // Espacement de ligne (ajustable)
        }

        // On écrit le mot (sauf si c'est juste un espace en début de ligne)
        if (!(currentX === startX && word.trim() === "")) {
          doc.text(word, currentX, currentY);
          currentX += wordWidth;
        }
      });
    });

    // --- FIN DU PARAGRAPHE ---

    doc.setLineHeightFactor(1.15);
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    let peryod = "";

    if (Mois_lib.trim() === "Décembre" || Mois_lib.trim() === "Decembre") {
      peryod = " " + Mois_lib.trim() + " " + (parseInt(annee) - 1).toString();
    } else {
      peryod = " " + Mois_lib.trim() + " " + annee;
    }
    doc.setFontSize(16);
    doc.text(peryod, 76, 120, { charSpace: "0.7", align: "justify" });

    doc.setFontSize(12);

    let debut = 130;
    let lineheight = 8;
    doc.setFont("helvetica", "bold");

    doc.text("MATIÈRES", 48, 130, { charSpace: "0.7" });
    doc.text("NOTES", 124, 130, { charSpace: "0.7" });
    doc.setFont("times", "normal");
    let qteNotes = 0;

    notes.forEach((n) => {
      if (
        n.coef !== "" &&
        n.note !== "" &&
        n.matiere !== "" &&
        n.note !== null &&
        n.matiere !== null
      ) {
        qteNotes += parseInt(n.note);
        debut += lineheight;
        doc.text(n.matiere, 48, debut, { charSpace: "0.7" });
        doc.text(
          n.note.padStart(3, " ") + "   /   " + n.coef,
          124,
          debut,
          { charSpace: "0.3" },
          "right",
        );
      }
    });

    doc.setFont("helvetica", "bold");
    doc.text(
      qteNotes.toString() + " sur " + TotCoef.toString(),
      100,
      256,
      null,
      null,
      "center",
    );

    let dir_bunexe = "Directeur";
    let bunexe = "Bureau National des Examens d'Etat";
    let certification_ = " Chef du Service";
    let certification__ = "de Certifiation et d'equivalence";

    doc.setFont("helvetica", "bold");
    doc.text(certification_, 40, 270, null, null, "center");
    doc.text(certification__, 40, 276, null, null, "center");

    doc.setFont("helvetica", "bold");
    doc.text(dir_bunexe, 150, 270, null, null, "center");
    doc.text(bunexe, 150, 276, null, null, "center");

    doc.addImage("Elius-Louis.png", "png", 20, 258, 50, 15);
    doc.addImage("Signature_dirBunexe.png", "png", 128, 257, 50, 16);

    if (typeof les_documents !== "undefined") {
      if (les_documents.includes("legalise seulement")) {
        doc.addImage("menfp_af.png", "png", 10, 210, 20, 20);
        doc.addImage("daj_menfp.png", "png", 10, 233, 40, 6);
      }
      if (les_documents.includes("legalise menfp mae")) {
        doc.addImage("menfp_af.png", "png", 10, 210, 20, 20);
        doc.addImage("daj_menfp.png", "png", 10, 233, 40, 6);
        doc.addImage("mae.jpeg", "jpeg", 170, 210, 20, 20);
        doc.addImage("daj_mae.png", "png", 170, 223, 30, 20);
      }
    }

    if (window.screen.availWidth < 641) {
      document.getElementById("output").data = doc.output("datauristring");
    } else {
      const pdfBlob = doc.output("blob");
      const url = URL.createObjectURL(pdfBlob);
      document.getElementById("output").data = url;

      doc.save(`bunexe_e_certificat-R-${identifiant}-${nomComplet}.pdf`);
      window.currentPdfUrl = url;
    }
  };

  const printReleve4 = (
    img_,
    identifiant,
    nom,
    prenom,
    annee,
    dnaiss_,
    lieu_,
    matricule,
    moy,
    section_,
    session_,
    Section_lib,
    sexe_,
    notes,
    TotCoef,
    Mois_lib,
  ) => {
    if (window.currentPdfUrl) {
      URL.revokeObjectURL(window.currentPdfUrl);
    }
    const doc = new jsPDF(); //, "mm", "letter");

    // Intégrer l'image de fond dans le PDF
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    doc.addImage(
      "bordures/releve_armoirie_centree_v2.png",
      "PNG",
      0,
      0,
      pageWidth,
      pageHeight,
    );

    doc.setFont("times", "bold");
    doc.setFontSize(14);

    let Entete = "MINISTÈRE DE L’ÉDUCATION NATIONALE";
    let Entete2 = "ET DE LA FORMATION PROFESSIONNELLE";

    doc.text(Entete, 38, 44, { charSpace: "0.8" }, null, null, "center");
    doc.text(Entete2, 38, 52, { charSpace: "0.7" }, null, null, "center");

    doc.setFontSize(12);
    let dg = "DIRECTION GÉNÉRALE";
    doc.text(dg, 70, 62, { charSpace: "0.7" }, null, null, "center");
    doc.setFontSize(12);
    doc.setFont("times", "bold");

    const aujourdHui = new Date();
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const dateFormatee = new Intl.DateTimeFormat("fr-FR", options).format(
      aujourdHui,
    );

    doc.setFont("helvetica", "italic");
    doc.text("Le " + dateFormatee, 176, 70, {
      charSpace: "0.7",
      align: "right",
    });

    doc.setFontSize(12);
    doc.setFont("times", "bold");
    let releve = "RELEVÉ DE NOTES";
    doc.text(releve, 76, 76, { charSpace: "0.7" }, null, null, "center");

    doc.addImage(img_, "png", 18, 54, 25, 25);
    doc.setFontSize(12);

    // --- PRÉPARATION DES VARIABLES ---
    let nomComplet =
      nom.trim() + " " + prenom.trim().split(" ").map(capitalize).join(" ");
    let lieu = lieu_.trim();
    let sexe = sexe_ === "1" ? "Monsieur" : "Mademoiselle";

    let section = "";
    if (["T", "U", "V", "X"].includes(session_)) {
      section = "UNIQUE, Secondaire IV à la série " + Section_lib;
    } else {
      section =
        "Secondaire, Section " + section_.substr(section_.length - 1, 1);
    }

    let typeExam = ["T", "U", "V", "X"].includes(session_)
      ? "du BAC "
      : "de fin d'études ";

    // --- IMPRESSION DU TEXTE EN FORMAT MIXTE (NORMAL / EN GRAS) ---
    doc.setFont("times", "normal");
    doc.setLineHeightFactor(1.5);

    // Coordonnées de départ pour le bloc de texte
    let startX = 15;
    let startY = 82;
    let currentX = startX;
    let currentY = startY;
    const maxWidth = 180; // Largeur maximale disponible pour le texte sur la page
    const spaceWidth = doc.getTextWidth(" ");

    // Définition des segments de texte avec leur style respectif
    const fragments = [
      {
        text: "La Direction Générale du Ministère de l'Education Nationale et de la Formation Professionnelle certifie que ",
        style: "normal",
      },
      { text: `${sexe} ${nomComplet} `, style: "bold" },
      { text: "né(e) le ", style: "normal" },
      { text: `${dnaiss_} `, style: "bold" },
      { text: `à (au, aux) ${lieu}, enregistré(e) au No. `, style: "normal" },
      { text: `${matricule}, `, style: "bold" },
      { text: `a participé aux Examens ${typeExam}`, style: "normal" },
      { text: `${section} `, style: "bold" },
      {
        text: "et a obtenu les notes suivantes pour la session de :",
        style: "normal",
      },
    ];

    // Algorithme de rendu mot par mot avec retour à la ligne automatique
    fragments.forEach((frag) => {
      doc.setFont("times", frag.style);
      const words = frag.text.split(/(\s+)/); // Découpe en conservant les espaces

      words.forEach((word) => {
        if (!word) return;

        const wordWidth = doc.getTextWidth(word);

        // Si le mot dépasse la largeur maximale autorisée, on saute à la ligne suivante
        if (currentX + wordWidth > maxWidth + startX) {
          currentX = startX;
          currentY += 7; // Saut de ligne ajustable (en mm)
        }

        // On dessine le texte (en évitant d'écrire un espace vide en début de ligne)
        if (!(currentX === startX && word.trim() === "")) {
          doc.text(word, currentX, currentY);
          currentX += wordWidth;
        }
      });
    });

    // --- POSITIONNEMENT DYNAMIQUE DE LA PÉRIODE (ex: Juin 2018) ---
    doc.setLineHeightFactor(1.15);
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    let peryod = "";

    if (Mois_lib.trim() === "Décembre" || Mois_lib.trim() === "Decembre") {
      peryod = " " + Mois_lib.trim() + " " + (parseInt(annee) - 1).toString();
    } else {
      peryod = " " + Mois_lib.trim() + " " + annee;
    }

    doc.setFontSize(16);
    // Se positionne automatiquement 8mm sous la fin réelle du paragraphe précédent
    currentY += 8;
    doc.text(peryod, 76, currentY, { charSpace: "0.7", align: "justify" });

    // --- POSITIONNEMENT DYNAMIQUE DE L'EN-TÊTE DU TABLEAU ---
    let debut = currentY + 10; // Le tableau suit le mouvement (10mm sous la période)
    let lineheight = 8;
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");

    doc.text("MATIÈRES", 48, debut, { charSpace: "0.7" });
    doc.text("NOTES", 124, debut, { charSpace: "0.7" });

    doc.setFont("times", "normal");
    let qteNotes = 0;

    // Remplissage des notes récoltées
    notes.forEach((n) => {
      if (
        n.coef !== "" &&
        n.note !== "" &&
        n.matiere !== "" &&
        n.note !== null &&
        n.matiere !== null
      ) {
        qteNotes += parseInt(n.note);
        debut += lineheight;
        doc.text(n.matiere, 48, debut, { charSpace: "0.7" });
        doc.text(
          n.note.padStart(3, " ") + "   /   " + n.coef,
          124,
          debut,
          { charSpace: "0.3" },
          "right",
        );
      }
    });

    // --- BLOC DE SIGNATURES ET BAS DE PAGE (Fixes sur le support papier) ---
    doc.setFont("helvetica", "bold");
    doc.text(
      qteNotes.toString() + " sur " + TotCoef.toString(),
      100,
      256,
      null,
      null,
      "center",
    );

    let dir_bunexe = "Directeur";
    let bunexe = "Bureau National des Examens d'Etat";
    let certification_ = " Chef du Service";
    let certification__ = "de Certifiation et d'equivalence";

    doc.setFont("helvetica", "bold");
    doc.text(certification_, 40, 270, null, null, "center");
    doc.text(certification__, 40, 276, null, null, "center");

    doc.setFont("helvetica", "bold");
    doc.text(dir_bunexe, 150, 270, null, null, "center");
    doc.text(bunexe, 150, 276, null, null, "center");

    doc.addImage("Elius-Louis.png", "png", 20, 258, 50, 15);
    doc.addImage("Signature_dirBunexe.png", "png", 128, 257, 50, 16);

    if (typeof les_documents !== "undefined") {
      if (les_documents.includes("legalise seulement")) {
        doc.addImage("menfp_af.png", "png", 10, 210, 20, 20);
        doc.addImage("daj_menfp.png", "png", 10, 233, 40, 6);
      }
      if (les_documents.includes("legalise menfp mae")) {
        doc.addImage("menfp_af.png", "png", 10, 210, 20, 20);
        doc.addImage("daj_menfp.png", "png", 10, 233, 40, 6);
        doc.addImage("mae.jpeg", "jpeg", 170, 210, 20, 20);
        doc.addImage("daj_mae.png", "png", 170, 223, 30, 20);
      }
    }

    // --- SORTIE ET ENREGISTREMENT ---
    if (window.screen.availWidth < 641) {
      document.getElementById("output").data = doc.output("datauristring");
    } else {
      const pdfBlob = doc.output("blob");
      const url = URL.createObjectURL(pdfBlob);
      document.getElementById("output").data = url;

      doc.save(`bunexe_e_certificat-R-${identifiant}-${nomComplet}.pdf`);
      window.currentPdfUrl = url;
    }
  };

  const printReleve5 = (
    img_,
    identifiant,
    nom,
    prenom,
    annee,
    dnaiss_,
    lieu_,
    matricule,
    moy,
    section_,
    session_,
    Section_lib,
    sexe_,
    notes,
    TotCoef,
    Mois_lib,
  ) => {
    if (window.currentPdfUrl) {
      URL.revokeObjectURL(window.currentPdfUrl);
    }
    const doc = new jsPDF(); //, "mm", "letter");

    // Intégrer l'image de fond dans le PDF
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    doc.addImage(
      "bordures/releve_armoirie_centree_v2.png",
      "PNG",
      0,
      0,
      pageWidth,
      pageHeight,
    );

    doc.setFont("times", "bold");
    doc.setFontSize(14);

    let Entete = "MINISTÈRE DE L’ÉDUCATION NATIONALE";
    let Entete2 = "ET DE LA FORMATION PROFESSIONNELLE";

    doc.text(Entete, 38, 44, { charSpace: "0.8" }, null, null, "center");
    doc.text(Entete2, 38, 52, { charSpace: "0.7" }, null, null, "center");

    doc.setFontSize(12);
    let dg = "DIRECTION GÉNÉRALE";
    doc.text(dg, 70, 62, { charSpace: "0.7" }, null, null, "center");
    doc.setFontSize(12);
    doc.setFont("times", "bold");

    const aujourdHui = new Date();
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const dateFormatee = new Intl.DateTimeFormat("fr-FR", options).format(
      aujourdHui,
    );

    doc.setFont("helvetica", "italic");
    doc.text("Le " + dateFormatee, 176, 70, {
      charSpace: "0.7",
      align: "right",
    });

    doc.setFontSize(12);
    doc.setFont("times", "bold");
    let releve = "RELEVÉ DE NOTES";
    doc.text(releve, 76, 76, { charSpace: "0.7" }, null, null, "center");

    doc.addImage(img_, "png", 18, 54, 25, 25);
    doc.setFontSize(12);

    // --- PRÉPARATION DES VARIABLES ---
    let nomComplet =
      nom.trim() + " " + prenom.trim().split(" ").map(capitalize).join(" ");
    let lieu = lieu_.trim();
    let sexe = sexe_ === "1" ? "Monsieur" : "Mademoiselle";

    let section = "";
    if (["T", "U", "V", "X"].includes(session_)) {
      section = "UNIQUE, Secondaire IV à la série " + Section_lib;
    } else {
      section =
        "Secondaire, Section " + section_.substr(section_.length - 1, 1);
    }

    let typeExam = ["T", "U", "V", "X"].includes(session_)
      ? "du BAC "
      : "de fin d'études ";

    // --- IMPRESSION DU TEXTE EN FORMAT MIXTE (NORMAL / EN GRAS) ---
    doc.setFont("times", "normal");
    doc.setLineHeightFactor(1.4);

    // Coordonnées de départ pour le bloc de texte de l'état civil
    let startX = 15;
    let startY = 82;
    let currentX = startX;
    let currentY = startY;
    const maxWidth = 180;

    // Définition des segments de texte avec leur style respectif
    const fragments = [
      {
        text: "La Direction Générale du Ministère de l'Education Nationale et de la Formation Professionnelle certifie que ",
        style: "normal",
      },
      { text: `${sexe} ${nomComplet} `, style: "bold" },
      { text: "né(e) le ", style: "normal" },
      { text: `${dnaiss_} `, style: "bold" },
      { text: `à (au, aux) ${lieu}, enregistré(e) au No. `, style: "normal" },
      { text: `${matricule}, `, style: "bold" },
      { text: `a participé aux Examens ${typeExam}`, style: "normal" },
      { text: `${section} `, style: "bold" },
      {
        text: "et a obtenu les notes suivantes pour la session de :",
        style: "normal",
      },
    ];

    // Algorithme de rendu mot par mot pour l'en-tête descriptif
    fragments.forEach((frag) => {
      doc.setFont("times", frag.style);
      const words = frag.text.split(/(\s+)/);

      words.forEach((word) => {
        if (!word) return;

        const wordWidth = doc.getTextWidth(word);

        if (currentX + wordWidth > maxWidth + startX) {
          currentX = startX;
          currentY += 6.5; // Espacement de ligne ajusté pour l'en-tête
        }

        if (!(currentX === startX && word.trim() === "")) {
          doc.text(word, currentX, currentY);
          currentX += wordWidth;
        }
      });
    });

    // --- POSITIONNEMENT FIXE SÉCURISÉ DE LA PÉRIODE (ex: Juin 2019) ---
    doc.setLineHeightFactor(1.15);
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    let peryod = "";

    if (Mois_lib.trim() === "Décembre" || Mois_lib.trim() === "Decembre") {
      peryod = " " + Mois_lib.trim() + " " + (parseInt(annee) - 1).toString();
    } else {
      peryod = " " + Mois_lib.trim() + " " + annee;
    }

    doc.setFontSize(16);
    // Position fixe et centrée sous le paragraphe pour éviter l'intrusion dans le tableau
    doc.text(peryod, 100, 118, { charSpace: "0.7", align: "center" });

    // --- POSITIONNEMENT FIXE DU TABLEAU DES MATIÈRES ---
    let debut = 128;
    let lineheight = 7.5; // Hauteur de ligne condensée pour s'assurer que toutes les matières logent avant la ligne 256
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");

    doc.text("MATIÈRES", 48, debut, { charSpace: "0.7" });
    doc.text("NOTES", 124, debut, { charSpace: "0.7" });

    doc.setFont("times", "normal");
    let qteNotes = 0;

    // Remplissage du tableau des notes
    notes.forEach((n) => {
      if (
        n.coef !== "" &&
        n.note !== "" &&
        n.matiere !== "" &&
        n.note !== null &&
        n.matiere !== null
      ) {
        qteNotes += parseInt(n.note);
        debut += lineheight;
        doc.text(n.matiere, 48, debut, { charSpace: "0.7" });
        doc.text(
          n.note.padStart(3, " ") + "   /   " + n.coef,
          124,
          debut,
          { charSpace: "0.3" },
          "right",
        );
      }
    });

    // --- BLOC DE SIGNATURES ET CERTIFICATION (CONSERVÉ FIXE) ---
    doc.setFont("helvetica", "bold");
    doc.text(
      qteNotes.toString() + " sur " + TotCoef.toString(),
      100,
      256,
      null,
      null,
      "center",
    );

    let dir_bunexe = "Directeur";
    let bunexe = "Bureau National des Examens d'Etat";
    let certification_ = " Chef du Service";
    let certification__ = "de Certifiation et d'equivalence";

    doc.setFont("helvetica", "bold");
    doc.text(certification_, 40, 270, null, null, "center");
    doc.text(certification__, 40, 276, null, null, "center");

    doc.setFont("helvetica", "bold");
    doc.text(dir_bunexe, 150, 270, null, null, "center");
    doc.text(bunexe, 150, 276, null, null, "center");

    doc.addImage("Elius-Louis.png", "png", 20, 258, 50, 15);
    doc.addImage("Signature_dirBunexe.png", "png", 128, 257, 50, 16);

    if (typeof les_documents !== "undefined") {
      if (les_documents.includes("legalise seulement")) {
        doc.addImage("menfp_af.png", "png", 10, 210, 20, 20);
        doc.addImage("daj_menfp.png", "png", 10, 233, 40, 6);
      }
      if (les_documents.includes("legalise menfp mae")) {
        doc.addImage("menfp_af.png", "png", 10, 210, 20, 20);
        doc.addImage("daj_menfp.png", "png", 10, 233, 40, 6);
        doc.addImage("mae.jpeg", "jpeg", 170, 210, 20, 20);
        doc.addImage("daj_mae.png", "png", 170, 223, 30, 20);
      }
    }

    // --- TRAITEMENT DU FICHIER ET TÉLÉCHARGEMENT ---
    if (window.screen.availWidth < 641) {
      document.getElementById("output").data = doc.output("datauristring");
    } else {
      const pdfBlob = doc.output("blob");
      const url = URL.createObjectURL(pdfBlob);
      document.getElementById("output").data = url;

      doc.save(`bunexe_e_certificat-R-${identifiant}-${nomComplet}.pdf`);
      window.currentPdfUrl = url;
    }
  };

  const printReleve6 = (
    img_,
    identifiant,
    nom,
    prenom,
    annee,
    dnaiss_,
    lieu_,
    matricule,
    moy,
    section_,
    session_,
    Section_lib,
    sexe_,
    notes,
    TotCoef,
    Mois_lib,
  ) => {
    if (window.currentPdfUrl) {
      URL.revokeObjectURL(window.currentPdfUrl);
    }
    const doc = new jsPDF(); //, "mm", "letter");

    // Intégrer l'image de fond dans le PDF
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    doc.addImage(
      "bordures/releve_armoirie_centree_v2.png",
      "PNG",
      0,
      0,
      pageWidth,
      pageHeight,
    );

    doc.setFont("times", "bold");
    doc.setFontSize(14);

    let Entete = "MINISTÈRE DE L’ÉDUCATION NATIONALE";
    let Entete2 = "ET DE LA FORMATION PROFESSIONNELLE";

    doc.text(Entete, 38, 44, { charSpace: "0.8" }, null, null, "center");
    doc.text(Entete2, 38, 52, { charSpace: "0.7" }, null, null, "center");

    doc.setFontSize(12);
    let dg = "DIRECTION GÉNÉRALE";
    doc.text(dg, 70, 62, { charSpace: "0.7" }, null, null, "center");
    doc.setFontSize(12);
    doc.setFont("times", "bold");

    const aujourdHui = new Date();
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const dateFormatee = new Intl.DateTimeFormat("fr-FR", options).format(
      aujourdHui,
    );

    doc.setFont("helvetica", "italic");
    doc.text("Le " + dateFormatee, 176, 70, {
      charSpace: "0.7",
      align: "right",
    });

    doc.setFontSize(12);
    doc.setFont("times", "bold");
    let releve = "RELEVÉ DE NOTES";
    doc.text(releve, 76, 76, { charSpace: "0.7" }, null, null, "center");

    doc.addImage(img_, "png", 18, 54, 25, 25);
    doc.setFontSize(12);

    // --- PRÉPARATION DES VARIABLES ---
    let nomComplet =
      nom.trim() + " " + prenom.trim().split(" ").map(capitalize).join(" ");
    let lieu = lieu_.trim();
    let sexe = sexe_ === "1" ? "Monsieur" : "Mademoiselle";

    let section = "";
    if (["T", "U", "V", "X"].includes(session_)) {
      section = "UNIQUE, Secondaire IV à la série " + Section_lib;
    } else {
      section =
        "Secondaire, Section " + section_.substr(section_.length - 1, 1);
    }

    let typeExam = ["T", "U", "V", "X"].includes(session_)
      ? "du BAC "
      : "de fin d'études ";

    // --- IMPRESSION DU TEXTE EN FORMAT MIXTE (NORMAL / EN GRAS) ---
    doc.setFont("times", "normal");
    doc.setLineHeightFactor(1.4);

    // Coordonnées de départ pour le bloc de texte de l'état civil
    let startX = 15;
    let startY = 82;
    let currentX = startX;
    let currentY = startY;
    const maxWidth = 180;

    // Définition des segments de texte avec leur style respectif
    const fragments = [
      {
        text: "La Direction Générale du Ministère de l'Education Nationale et de la Formation Professionnelle certifie que ",
        style: "normal",
      },
      { text: `${sexe} ${nomComplet} `, style: "bold" },
      { text: "né(e) le ", style: "normal" },
      { text: `${dnaiss_} `, style: "bold" },
      { text: `à (au, aux) ${lieu}, enregistré(e) au No. `, style: "normal" },
      { text: `${matricule}, `, style: "bold" },
      { text: `a participé aux Examens ${typeExam}`, style: "normal" },
      { text: `${section} `, style: "bold" },
      {
        text: "et a obtenu les notes suivantes pour la session de :",
        style: "normal",
      },
    ];

    // Algorithme de rendu mot par mot pour l'en-tête descriptif
    fragments.forEach((frag) => {
      doc.setFont("times", frag.style);
      const words = frag.text.split(/(\s+)/);

      words.forEach((word) => {
        if (!word) return;

        const wordWidth = doc.getTextWidth(word);

        if (currentX + wordWidth > maxWidth + startX) {
          currentX = startX;
          currentY += 6.5; // Espacement de ligne ajusté pour l'en-tête
        }

        if (!(currentX === startX && word.trim() === "")) {
          doc.text(word, currentX, currentY);
          currentX += wordWidth;
        }
      });
    });

    // --- POSITIONNEMENT FIXE SÉCURISÉ DE LA PÉRIODE (ex: Juin 2019) ---
    doc.setLineHeightFactor(1.15);
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    let peryod = "";

    if (Mois_lib.trim() === "Décembre" || Mois_lib.trim() === "Decembre") {
      peryod = " " + Mois_lib.trim() + " " + (parseInt(annee) - 1).toString();
    } else {
      peryod = " " + Mois_lib.trim() + " " + annee;
    }

    doc.setFontSize(16);
    // Position fixe et centrée sous le paragraphe pour éviter l'intrusion dans le tableau
    doc.text(peryod, 100, 118, { charSpace: "0.7", align: "center" });

    // --- POSITIONNEMENT FIXE DU TABLEAU DES MATIÈRES ---
    let debut = 128;
    let lineheight = 7.5; // Hauteur de ligne condensée pour s'assurer que toutes les matières logent avant la ligne 256
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");

    doc.text("MATIÈRES", 48, debut, { charSpace: "0.7" });
    doc.text("NOTES", 124, debut, { charSpace: "0.7" });

    doc.setFont("times", "normal");
    let qteNotes = 0;

    // Remplissage du tableau des notes
    notes.forEach((n) => {
      if (
        n.coef !== "" &&
        n.note !== "" &&
        n.matiere !== "" &&
        n.note !== null &&
        n.matiere !== null
      ) {
        qteNotes += parseInt(n.note);
        debut += lineheight;
        doc.text(n.matiere, 48, debut, { charSpace: "0.7" });
        doc.text(
          n.note.padStart(3, " ") + "   /   " + n.coef,
          124,
          debut,
          { charSpace: "0.3" },
          "right",
        );
      }
    });

    // --- BLOC DE SIGNATURES ET CERTIFICATION (CONSERVÉ FIXE) ---
    doc.setFont("helvetica", "bold");
    doc.text(
      qteNotes.toString() + " sur " + TotCoef.toString(),
      100,
      256,
      null,
      null,
      "center",
    );

    let dir_bunexe = "Directeur";
    let bunexe = "Bureau National des Examens d'Etat";
    let certification_ = " Chef du Service";
    let certification__ = "de Certifiation et d'equivalence";

    doc.setFont("helvetica", "bold");
    doc.text(certification_, 40, 270, null, null, "center");
    doc.text(certification__, 40, 276, null, null, "center");

    doc.setFont("helvetica", "bold");
    doc.text(dir_bunexe, 150, 270, null, null, "center");
    doc.text(bunexe, 150, 276, null, null, "center");

    doc.addImage("Elius-Louis.png", "png", 20, 258, 50, 15);
    doc.addImage("Signature_dirBunexe.png", "png", 128, 257, 50, 16);

    if (typeof les_documents !== "undefined") {
      if (les_documents.includes("legalise seulement")) {
        doc.addImage("menfp_af.png", "png", 10, 210, 20, 20);
        doc.addImage("daj_menfp.png", "png", 10, 233, 40, 6);
      }
      if (les_documents.includes("legalise menfp mae")) {
        doc.addImage("menfp_af.png", "png", 10, 210, 20, 20);
        doc.addImage("daj_menfp.png", "png", 10, 233, 40, 6);
        doc.addImage("mae.jpeg", "jpeg", 170, 210, 20, 20);
        doc.addImage("daj_mae.png", "png", 170, 223, 30, 20);
      }
    }

    // --- TRAITEMENT DU FICHIER ET TÉLÉCHARGEMENT ---
    if (window.screen.availWidth < 641) {
      document.getElementById("output").data = doc.output("datauristring");
    } else {
      const pdfBlob = doc.output("blob");
      const url = URL.createObjectURL(pdfBlob);
      document.getElementById("output").data = url;

      doc.save(`bunexe_e_certificat-R-${identifiant}-${nomComplet}.pdf`);
      window.currentPdfUrl = url;
    }
  };

  const printReleve7 = (
    img_,
    identifiant,
    nom,
    prenom,
    annee,
    dnaiss_,
    lieu_,
    matricule,
    moy,
    section_,
    session_,
    Section_lib,
    sexe_,
    notes,
    TotCoef,
    Mois_lib,
  ) => {
    if (window.currentPdfUrl) {
      URL.revokeObjectURL(window.currentPdfUrl);
    }
    const doc = new jsPDF(); //, "mm", "letter");

    // Intégrer l'image de fond dans le PDF
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    doc.addImage(
      "bordures/releve_armoirie_centree_v2.png",
      "PNG",
      0,
      0,
      pageWidth,
      pageHeight,
    );

    doc.setFont("times", "bold");
    doc.setFontSize(14);

    let Entete = "MINISTÈRE DE L’ÉDUCATION NATIONALE";
    let Entete2 = "ET DE LA FORMATION PROFESSIONNELLE";

    doc.text(Entete, 38, 44, { charSpace: "0.8" }, null, null, "center");
    doc.text(Entete2, 38, 52, { charSpace: "0.7" }, null, null, "center");

    doc.setFontSize(12);
    let dg = "DIRECTION GÉNÉRALE";
    doc.text(dg, 70, 62, { charSpace: "0.7" }, null, null, "center");
    doc.setFontSize(12);
    doc.setFont("times", "bold");

    const aujourdHui = new Date();
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const dateFormatee = new Intl.DateTimeFormat("fr-FR", options).format(
      aujourdHui,
    );

    doc.setFont("times", "italic"); // Remplacé helvetica par times pour l'homogénéité
    doc.text("Le " + dateFormatee, 176, 70, {
      charSpace: "0.7",
      align: "right",
    });

    doc.setFontSize(12);
    doc.setFont("times", "bold");
    let releve = "RELEVÉ DE NOTES";
    doc.text(releve, 76, 76, { charSpace: "0.7" }, null, null, "center");

    doc.addImage(img_, "png", 18, 54, 25, 25);
    doc.setFontSize(12);

    // --- PRÉPARATION DES VARIABLES ---
    let nomComplet =
      nom.trim() + " " + prenom.trim().split(" ").map(capitalize).join(" ");
    let lieu = lieu_.trim();
    let sexe = sexe_ === "1" ? "Monsieur" : "Mademoiselle";

    let section = "";
    if (["T", "U", "V", "X"].includes(session_)) {
      section = "UNIQUE, Secondaire IV à la série " + Section_lib;
    } else {
      section =
        "Secondaire, Section " + section_.substr(section_.length - 1, 1);
    }

    let typeExam = ["T", "U", "V", "X"].includes(session_)
      ? "du BAC "
      : "de fin d'études ";

    // --- IMPRESSION DU TEXTE EN TIMES NEW ROMAN (NORMAL / EN GRAS) ---
    doc.setFont("times", "normal");
    doc.setLineHeightFactor(1.4);

    // Coordonnées de départ pour le bloc de texte de l'état civil
    let startX = 15;
    let startY = 82;
    let currentX = startX;
    let currentY = startY;
    const maxWidth = 180;

    // Définition des segments avec micro-espaces pour éviter le collage des mots
    const fragments = [
      {
        text: "La Direction Générale du Ministère de l'Education Nationale et de la Formation Professionnelle certifie que ",
        style: "normal",
      },
      { text: `${sexe} ${nomComplet}`, style: "bold" },
      { text: " né(e) le ", style: "normal" },
      { text: `${dnaiss_}`, style: "bold" },
      { text: ` à (au, aux) ${lieu}, enregistré(e) au No. `, style: "normal" },
      { text: `${matricule}`, style: "bold" },
      { text: `, a participé aux Examens ${typeExam}`, style: "normal" },
      { text: `${section}`, style: "bold" },
      {
        text: " et a obtenu les notes suivantes pour la session de :",
        style: "normal",
      },
    ];

    // Algorithme de rendu mot par mot en Times New Roman
    fragments.forEach((frag) => {
      doc.setFont("times", frag.style);
      const words = frag.text.split(/(\s+)/);

      words.forEach((word) => {
        if (!word) return;

        const wordWidth = doc.getTextWidth(word);

        if (currentX + wordWidth > maxWidth + startX) {
          currentX = startX;
          currentY += 6.5;
        }

        if (!(currentX === startX && word.trim() === "")) {
          doc.text(word, currentX, currentY);
          currentX += wordWidth;
        }
      });
    });

    // --- POSITIONNEMENT FIXE SÉCURISÉ DE LA PÉRIODE (ex: Juin 2019) ---
    doc.setLineHeightFactor(1.15);
    doc.setFontSize(14);
    doc.setFont("times", "bold"); // Remplacé helvetica par times
    let peryod = "";

    if (Mois_lib.trim() === "Décembre" || Mois_lib.trim() === "Decembre") {
      peryod = " " + Mois_lib.trim() + " " + (parseInt(annee) - 1).toString();
    } else {
      peryod = " " + Mois_lib.trim() + " " + annee;
    }

    doc.setFontSize(16);
    doc.text(peryod, 100, 118, { charSpace: "0.7", align: "center" });

    // --- POSITIONNEMENT FIXE DU TABLEAU DES MATIÈRES ---
    let debut = 128;
    let lineheight = 7.5;
    doc.setFontSize(12);
    doc.setFont("times", "bold"); // Passage en Times Bold pour une charte graphique épurée

    doc.text("MATIÈRES", 48, debut, { charSpace: "0.7" });
    doc.text("NOTES", 124, debut, { charSpace: "0.7" });

    doc.setFont("times", "normal");
    let qteNotes = 0;

    // Remplissage du tableau des notes
    notes.forEach((n) => {
      if (
        n.coef !== "" &&
        n.note !== "" &&
        n.matiere !== "" &&
        n.note !== null &&
        n.matiere !== null
      ) {
        qteNotes += parseInt(n.note);
        debut += lineheight;
        doc.text(n.matiere, 48, debut, { charSpace: "0.7" });
        doc.text(
          n.note.padStart(3, " ") + "   /   " + n.coef,
          124,
          debut,
          { charSpace: "0.3" },
          "right",
        );
      }
    });

    // --- BLOC DE SIGNATURES ET CERTIFICATION (CONSERVÉ FIXE EN BAS) ---
    doc.setFont("times", "bold"); // Remplacé helvetica par times
    doc.text(
      qteNotes.toString() + " sur " + TotCoef.toString(),
      100,
      256,
      null,
      null,
      "center",
    );

    let dir_bunexe = "Directeur";
    let bunexe = "Bureau National des Examens d'Etat";
    let certification_ = " Chef du Service";
    let certification__ = "de Certifiation et d'equivalence";

    doc.text(certification_, 40, 270, null, null, "center");
    doc.text(certification__, 40, 276, null, null, "center");

    doc.text(dir_bunexe, 150, 270, null, null, "center");
    doc.text(bunexe, 150, 276, null, null, "center");

    doc.addImage("Elius-Louis.png", "png", 20, 258, 50, 15);
    doc.addImage("Signature_dirBunexe.png", "png", 128, 257, 50, 16);

    if (typeof les_documents !== "undefined") {
      if (les_documents.includes("legalise seulement")) {
        doc.addImage("menfp_af.png", "png", 10, 210, 20, 20);
        doc.addImage("daj_menfp.png", "png", 10, 233, 40, 6);
      }
      if (les_documents.includes("legalise menfp mae")) {
        doc.addImage("menfp_af.png", "png", 10, 210, 20, 20);
        doc.addImage("daj_menfp.png", "png", 10, 233, 40, 6);
        doc.addImage("mae.jpeg", "jpeg", 170, 210, 20, 20);
        doc.addImage("daj_mae.png", "png", 170, 223, 30, 20);
      }
    }

    // --- TRAITEMENT DU FICHIER ET TÉLÉCHARGEMENT ---
    if (window.screen.availWidth < 641) {
      document.getElementById("output").data = doc.output("datauristring");
    } else {
      const pdfBlob = doc.output("blob");
      const url = URL.createObjectURL(pdfBlob);
      document.getElementById("output").data = url;

      doc.save(`bunexe_e_certificat-R-${identifiant}-${nomComplet}.pdf`);
      window.currentPdfUrl = url;
    }
  };

  const printReleve8 = (
    img_,
    identifiant,
    nom,
    prenom,
    annee,
    dnaiss_,
    lieu_,
    matricule,
    moy,
    section_,
    session_,
    Section_lib,
    sexe_,
    notes,
    TotCoef,
    Mois_lib,
  ) => {
    if (window.currentPdfUrl) {
      URL.revokeObjectURL(window.currentPdfUrl);
    }
    const doc = new jsPDF(); //, "mm", "letter");

    // Intégrer l'image de fond dans le PDF
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    doc.addImage(
      "bordures/releve_armoirie_centree_v2.png",
      "PNG",
      0,
      0,
      pageWidth,
      pageHeight,
    );

    doc.setFont("times", "bold");
    doc.setFontSize(14);

    let Entete = "MINISTÈRE DE L’ÉDUCATION NATIONALE";
    let Entete2 = "ET DE LA FORMATION PROFESSIONNELLE";

    doc.text(Entete, 38, 44, { charSpace: "0.8" }, null, null, "center");
    doc.text(Entete2, 38, 52, { charSpace: "0.7" }, null, null, "center");

    doc.setFontSize(12);
    let dg = "DIRECTION GÉNÉRALE";
    doc.text(dg, 70, 62, { charSpace: "0.7" }, null, null, "center");
    doc.setFontSize(12);
    doc.setFont("times", "bold");

    const aujourdHui = new Date();
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const dateFormatee = new Intl.DateTimeFormat("fr-FR", options).format(
      aujourdHui,
    );

    doc.setFont("times", "italic");
    doc.text("Le " + dateFormatee, 176, 70, {
      charSpace: "0.7",
      align: "right",
    });

    doc.setFontSize(12);
    doc.setFont("times", "bold");
    let releve = "RELEVÉ DE NOTES";
    doc.text(releve, 76, 76, { charSpace: "0.7" }, null, null, "center");

    doc.addImage(img_, "png", 18, 54, 25, 25);
    doc.setFontSize(12);

    // --- PRÉPARATION DES VARIABLES ---
    let nomComplet =
      nom.trim() + " " + prenom.trim().split(" ").map(capitalize).join(" ");
    let lieu = lieu_.trim();
    let sexe = sexe_ === "1" ? "Monsieur" : "Mademoiselle";

    // --- CONVERSION DE LA DATE DE NAISSANCE (ex: 21/06/1996 -> 21 Juin 1996) ---
    let dnaissFormatee = dnaiss_;
    if (dnaiss_ && dnaiss_.includes("/")) {
      const parts = dnaiss_.split("/");
      if (parts.length === 3) {
        // parts[0] = jj, parts[1] = mm, parts[2] = aaaa (on ajuste le mois car l'index de Date commence à 0)
        const dateObj = new Date(
          parseInt(parts[2]),
          parseInt(parts[1]) - 1,
          parseInt(parts[0]),
        );

        // On formate en français
        const formatNaiss = new Intl.DateTimeFormat("fr-FR", {
          day: "numeric",
          month: "long",
          year: "numeric",
        }).format(dateObj);

        // Mettre la première lettre du mois en majuscule (ex: "21 juin 1996" -> "21 Juin 1996")
        dnaissFormatee = formatNaiss.replace(
          /([a-zA-Zùûüéèàç]+)/,
          (match) => match.charAt(0).toUpperCase() + match.slice(1),
        );
      }
    }

    let section = "";
    if (["T", "U", "V", "X"].includes(session_)) {
      section = "UNIQUE, Secondaire IV à la série " + Section_lib;
    } else {
      section =
        "Secondaire, Section " + section_.substr(section_.length - 1, 1);
    }

    let typeExam = ["T", "U", "V", "X"].includes(session_)
      ? "du BAC "
      : "de fin d'études ";

    // --- IMPRESSION DU TEXTE EN TIMES NEW ROMAN (NORMAL / EN GRAS) ---
    doc.setFont("times", "normal");
    doc.setLineHeightFactor(1.4);

    let startX = 15;
    let startY = 82;
    let currentX = startX;
    let currentY = startY;
    const maxWidth = 180;

    /*
    const fragments = [
      {
        text: "La Direction Générale du Ministère de l'Education Nationale et de la Formation Professionnelle certifie que ",
        style: "normal",
      },
      { text: `${sexe} ${nomComplet}`, style: "bold" },
      { text: " né(e) le ", style: "normal" },
      { text: `${dnaissFormatee}`, style: "bold" }, // Utilisation de la nouvelle date formatée
      { text: ` à (au, aux) ${lieu}, enregistré(e) au No. `, style: "normal" },
      { text: `${matricule}`, style: "bold" },
      { text: `, a participé aux Examens ${typeExam}`, style: "normal" },
      { text: `${section}`, style: "bold" },
      {
        text: " et a obtenu les notes suivantes pour la session de :",
        style: "normal",
      },
    ];
*/
    const fragments = [
      {
        text: "La Direction Générale du Ministère de l'Education Nationale et de la Formation Professionnelle certifie que ",
        style: "normal",
      },
      { text: `${sexe} ${nomComplet}`, style: "bold" },
      { text: " né(e) le ", style: "normal" },
      { text: `${dnaissFormatee}`, style: "bold" },
      { text: ` à (au, aux) ${lieu}, enregistré(e) au No. `, style: "normal" },
      { text: `${matricule}`, style: "bold" },
      { text: `, a participé aux Examens ${typeExam}`, style: "normal" },
      { text: `${section} `, style: "bold" }, // <--- Notez l'espace ajouté ICI juste après la variable section
      {
        text: "et a obtenu les notes suivantes pour la session de :",
        style: "normal",
      }, // <--- Et on retire l'espace initial ici
    ];
    fragments.forEach((frag) => {
      doc.setFont("times", frag.style);
      const words = frag.text.split(/(\s+)/);

      words.forEach((word) => {
        if (!word) return;

        const wordWidth = doc.getTextWidth(word);

        if (currentX + wordWidth > maxWidth + startX) {
          currentX = startX;
          currentY += 6.5;
        }

        if (!(currentX === startX && word.trim() === "")) {
          doc.text(word, currentX, currentY);
          currentX += wordWidth;
        }
      });
    });

    // --- POSITIONNEMENT FIXE SÉCURISÉ DE LA PÉRIODE (ex: Juin 2019) ---
    doc.setLineHeightFactor(1.15);
    doc.setFontSize(14);
    doc.setFont("times", "bold");
    let peryod = "";

    if (Mois_lib.trim() === "Décembre" || Mois_lib.trim() === "Decembre") {
      peryod = " " + Mois_lib.trim() + " " + (parseInt(annee) - 1).toString();
    } else {
      peryod = " " + Mois_lib.trim() + " " + annee;
    }

    doc.setFontSize(16);
    doc.text(peryod, 100, 118, { charSpace: "0.7", align: "center" });

    // --- POSITIONNEMENT FIXE DU TABLEAU DES MATIÈRES ---
    let debut = 128;
    let lineheight = 7.5;
    doc.setFontSize(12);
    doc.setFont("times", "bold");

    doc.text("MATIÈRES", 48, debut, { charSpace: "0.7" });
    doc.text("NOTES", 124, debut, { charSpace: "0.7" });

    doc.setFont("times", "normal");
    let qteNotes = 0;

    notes.forEach((n) => {
      if (
        n.coef !== "" &&
        n.note !== "" &&
        n.matiere !== "" &&
        n.note !== null &&
        n.matiere !== null
      ) {
        qteNotes += parseInt(n.note);
        debut += lineheight;
        doc.text(n.matiere, 48, debut, { charSpace: "0.7" });
        doc.text(
          n.note.padStart(3, " ") + "   /   " + n.coef,
          124,
          debut,
          { charSpace: "0.3" },
          "right",
        );
      }
    });

    // --- BLOC DE SIGNATURES ET CERTIFICATION ---
    doc.setFont("times", "bold");
    doc.text(
      qteNotes.toString() + " sur " + TotCoef.toString(),
      100,
      256,
      null,
      null,
      "center",
    );

    let dir_bunexe = "Directeur";
    let bunexe = "Bureau National des Examens d'Etat";
    let certification_ = " Chef du Service";
    let certification__ = "de Certifiation et d'equivalence";

    doc.text(certification_, 40, 270, null, null, "center");
    doc.text(certification__, 40, 276, null, null, "center");

    doc.text(dir_bunexe, 150, 270, null, null, "center");
    doc.text(bunexe, 150, 276, null, null, "center");

    doc.addImage("Elius-Louis.png", "png", 20, 258, 50, 15);
    doc.addImage("Signature_dirBunexe.png", "png", 128, 257, 50, 16);

    if (typeof les_documents !== "undefined") {
      if (les_documents.includes("legalise seulement")) {
        doc.addImage("menfp_af.png", "png", 10, 210, 20, 20);
        doc.addImage("daj_menfp.png", "png", 10, 233, 40, 6);
      }
      if (les_documents.includes("legalise menfp mae")) {
        doc.addImage("menfp_af.png", "png", 10, 210, 20, 20);
        doc.addImage("daj_menfp.png", "png", 10, 233, 40, 6);
        doc.addImage("mae.jpeg", "jpeg", 170, 210, 20, 20);
        doc.addImage("daj_mae.png", "png", 170, 223, 30, 20);
      }
    }

    // --- TRAITEMENT DU FICHIER ET TÉLÉCHARGEMENT ---
    if (window.screen.availWidth < 641) {
      document.getElementById("output").data = doc.output("datauristring");
    } else {
      const pdfBlob = doc.output("blob");
      const url = URL.createObjectURL(pdfBlob);
      document.getElementById("output").data = url;

      doc.save(`bunexe_e_certificat-R-${identifiant}-${nomComplet}.pdf`);
      window.currentPdfUrl = url;
    }
  };

  const printReleve = (
    img_,
    identifiant,
    nom,
    prenom,
    annee,
    dnaiss_,
    lieu_,
    matricule,
    moy,
    section_,
    session_,
    Section_lib,
    sexe_,
    notes,
    TotCoef,
    Mois_lib,
  ) => {
    if (window.currentPdfUrl) {
      URL.revokeObjectURL(window.currentPdfUrl);
    }
    const doc = new jsPDF(); //, "mm", "letter");

    // Intégrer l'image de fond dans le PDF
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    doc.addImage(
      "bordures/releve_armoirie_centree_v2.png",
      "PNG",
      0,
      0,
      pageWidth,
      pageHeight,
    );

    doc.setFont("times", "bold");
    doc.setFontSize(14);

    let Entete = "MINISTÈRE DE L’ÉDUCATION NATIONALE";
    let Entete2 = "ET DE LA FORMATION PROFESSIONNELLE";

    doc.text(Entete, 38, 44, { charSpace: "0.8" }, null, null, "center");
    doc.text(Entete2, 38, 52, { charSpace: "0.7" }, null, null, "center");

    doc.setFontSize(12);
    let dg = "DIRECTION GÉNÉRALE";
    doc.text(dg, 70, 62, { charSpace: "0.7" }, null, null, "center");
    doc.setFontSize(12);
    doc.setFont("times", "bold");

    const aujourdHui = new Date();
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const dateFormatee = new Intl.DateTimeFormat("fr-FR", options).format(
      aujourdHui,
    );

    doc.setFont("times", "italic");
    doc.text("Le " + dateFormatee, 176, 70, {
      charSpace: "0.7",
      align: "right",
    });

    doc.setFontSize(12);
    doc.setFont("times", "bold");
    let releve = "RELEVÉ DE NOTES";
    doc.text(releve, 76, 76, { charSpace: "0.7" }, null, null, "center");

    doc.addImage(img_, "png", 18, 54, 25, 25);
    doc.setFontSize(12);

    // --- PRÉPARATION DES VARIABLES ---
    let nomComplet =
      nom.trim() + "  " + prenom.trim().split(" ").map(capitalize).join(" ");
    let lieu = lieu_.trim();
    let sexe = sexe_ === "1" ? "Monsieur" : "Mademoiselle";

    // --- CONVERSION DE LA DATE DE NAISSANCE (ex: 21/06/1996 -> 21 Juin 1996) ---
    let dnaissFormatee = dnaiss_;
    if (dnaiss_ && dnaiss_.includes("/")) {
      const parts = dnaiss_.split("/");
      if (parts.length === 3) {
        const dateObj = new Date(
          parseInt(parts[2]),
          parseInt(parts[1]) - 1,
          parseInt(parts[0]),
        );
        const formatNaiss = new Intl.DateTimeFormat("fr-FR", {
          day: "numeric",
          month: "long",
          year: "numeric",
        }).format(dateObj);
        dnaissFormatee = formatNaiss.replace(
          /([a-zA-Zùûüéèàç]+)/,
          (match) => match.charAt(0).toUpperCase() + match.slice(1),
        );
      }
    }

    // --- LOGIQUE TEXTUELLE AJUSTÉE POUR GÉRER LES GRAS / NORMAUX DU MINISTRE ---
    let isBacUnique = ["T", "U", "V", "X"].includes(session_);
    let segmentExamenText = isBacUnique ? "du " : "de fin d'études ";
    let segmentSuiteText = isBacUnique
      ? ", Secondaire IV à la série "
      : "Secondaire, Section " +
        section_.substr(section_.length - 1, 1) +
        " à la section ";

    // --- IMPRESSION DU TEXTE EN TIMES NEW ROMAN (NORMAL / EN GRAS) ---
    doc.setFont("times", "normal");
    doc.setLineHeightFactor(1.4);

    let startX = 15;
    let startY = 82;
    let currentX = startX;
    let currentY = startY;
    const maxWidth = 180;

    // Définition des segments respectant scrupuleusement les consignes du Ministre
    const fragments = [
      {
        text: "La Direction Générale du Ministère de l'Education Nationale et de la Formation Professionnelle certifie que ",
        style: "normal",
      },
      { text: `${sexe} ${nomComplet}`, style: "bold" },
      { text: " né(e) le ", style: "normal" },
      { text: `${dnaissFormatee}`, style: "bold" },
      { text: ` à (au, aux) ${lieu}, enregistré(e) au No. `, style: "normal" },
      { text: `${matricule}`, style: "bold" },
      {
        text: `, a participé aux Examens ${segmentExamenText}`,
        style: "normal",
      },
      // On isole "BAC UNIQUE" en gras si c'est le cas, sinon rien
      ...(isBacUnique ? [{ text: "BAC UNIQUE", style: "bold" }] : []),
      // "Secondaire IV à la série" repasse en normal
      { text: `${segmentSuiteText}`, style: "normal" },
      // Le nom de la série (ex: Sciences de la Vie et de la Terre) reste en gras
      { text: `${Section_lib} `, style: "bold" },
      {
        text: "et a obtenu les notes suivantes pour la session de :",
        style: "normal",
      },
    ];

    // Algorithme de rendu mot par mot en Times New Roman
    fragments.forEach((frag) => {
      doc.setFont("times", frag.style);
      const words = frag.text.split(/(\s+)/);

      words.forEach((word) => {
        if (!word) return;

        const wordWidth = doc.getTextWidth(word);

        if (currentX + wordWidth > maxWidth + startX) {
          currentX = startX;
          currentY += 6.5;
        }

        if (!(currentX === startX && word.trim() === "")) {
          doc.text(word, currentX, currentY);
          currentX += wordWidth;
        }
      });
    });

    // --- POSITIONNEMENT FIXE SÉCURISÉ DE LA PÉRIODE (ex: Juin 2019) ---
    doc.setLineHeightFactor(1.15);
    doc.setFontSize(14);
    doc.setFont("times", "bold");
    let peryod = "";

    if (Mois_lib.trim() === "Décembre" || Mois_lib.trim() === "Decembre") {
      peryod = " " + Mois_lib.trim() + " " + (parseInt(annee) - 1).toString();
    } else {
      peryod = " " + Mois_lib.trim() + " " + annee;
    }

    doc.setFontSize(16);
    doc.text(peryod, 100, 118, { charSpace: "0.7", align: "center" });

    // --- POSITIONNEMENT FIXE DU TABLEAU DES MATIÈRES ---
    let debut = 128;
    let lineheight = 7.5;
    doc.setFontSize(12);
    doc.setFont("times", "bold");

    doc.text("MATIÈRES", 48, debut, { charSpace: "0.7" });
    doc.text("NOTES", 124, debut, { charSpace: "0.7" });

    doc.setFont("times", "normal");
    let qteNotes = 0;

    notes.forEach((n) => {
      if (
        n.coef !== "" &&
        n.note !== "" &&
        n.matiere !== "" &&
        n.note !== null &&
        n.matiere !== null
      ) {
        qteNotes += parseInt(n.note);
        debut += lineheight;
        doc.text(n.matiere, 48, debut, { charSpace: "0.7" });
        doc.text(
          n.note.padStart(3, " ") + "   /   " + n.coef,
          124,
          debut,
          { charSpace: "0.3" },
          "right",
        );
      }
    });

    // --- BLOC DE SIGNATURES ET CERTIFICATION ---
    doc.setFont("times", "bold");
    doc.text(
      qteNotes.toString() + " sur " + TotCoef.toString(),
      100,
      256,
      null,
      null,
      "center",
    );

    let dir_bunexe = "Directeur";
    let bunexe = "Bureau National des Examens d'Etat";
    let certification_ = " Chef du Service";
    let certification__ = "de Certifiation et d'equivalence";

    doc.text(certification_, 40, 270, null, null, "center");
    doc.text(certification__, 40, 276, null, null, "center");

    doc.text(dir_bunexe, 150, 270, null, null, "center");
    doc.text(bunexe, 150, 276, null, null, "center");

    doc.addImage("Elius-Louis.png", "png", 20, 258, 50, 15);
    doc.addImage("Signature_dirBunexe.png", "png", 128, 257, 50, 16);

    if (typeof les_documents !== "undefined") {
      if (les_documents.includes("legalise seulement")) {
        doc.addImage("menfp_af.png", "png", 10, 210, 20, 20);
        doc.addImage("daj_menfp.png", "png", 10, 233, 40, 6);
      }
      if (les_documents.includes("legalise menfp mae")) {
        doc.addImage("menfp_af.png", "png", 10, 210, 20, 20);
        doc.addImage("daj_menfp.png", "png", 10, 233, 40, 6);
        doc.addImage("mae.jpeg", "jpeg", 170, 210, 20, 20);
        doc.addImage("daj_mae.png", "png", 170, 223, 30, 20);
      }
    }

    // --- TRAITEMENT DU FICHIER ET TÉLÉCHARGEMENT ---
    if (window.screen.availWidth < 641) {
      document.getElementById("output").data = doc.output("datauristring");
    } else {
      const pdfBlob = doc.output("blob");
      const url = URL.createObjectURL(pdfBlob);
      document.getElementById("output").data = url;

      doc.save(`bunexe_e_certificat-R-${identifiant}-${nomComplet}.pdf`);
      window.currentPdfUrl = url;
    }
  };

  const printPdf1 = (
    img_,
    identifiant,
    nom,
    prenom,
    annee,
    dnaiss_,
    lieu_,
    matricule,
    moy,
    section_,
    session_,
    Section_lib,
    Mois_lib,
  ) => {
    if (window.currentPdfUrl) {
      URL.revokeObjectURL(window.currentPdfUrl);
    }
    const doc = new jsPDF("landscape"); //, "mm", "letter");
    doc.setFont("times", "normal");
    // Integrer l'image de fond dans le PDF
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    // const imgData = 'data:image/png;base64,...'; // Base64 image

    doc.addImage(
      "bordures/certificat_bgd.png",
      "PNG",
      0,
      0,
      pageWidth,
      pageHeight,
    );

    /*let Entete =
      "MINISTERE DE L'EDUCATION NATIONALE ET DE LA FORMATION PROFESSIONNELLE";

    doc.addImage("armoirie.jpeg", "jpeg", 134, 14, 30, 30);

    doc.text(Entete, 146, 50, null, null, "center");
  */
    doc.setFont("helvetica", "bold");
    let diplome = "DIPLÔME DE FIN D'ETUDES SECONDAIRES";
    // doc.text(diplome, 144, 64, null, null, "center");
    doc.text(diplome, 144, 48, null, null, "center");
    let An_ = "";
    let An__ = "";
    if (
      session_ === "T" ||
      session_ === "U" ||
      session_ === "V" ||
      session_ === "X"
    ) {
      An__ = "Bac Unique " + annee;
    } else {
      An__ = annee;
    }
    An_ = annee;
    let programme = "SECONDAIRE";
    // doc.setFontSize(50);
    doc.setFontSize(20);
    doc.setFont("helvetica", "bold");
    doc.text(An__, 40, 144, null, 90);
    doc.text(programme, 260, 142, null, 90);
    // doc.text(text, 52, 40);

    // doc.addImage(img_, "png", 226, 50, 30, 30);
    doc.addImage(img_, "png", 34, 44, 28, 28);
    //doc.output("datauri");
    doc.setFontSize(30);
    doc.setFont("helvetica", "bold");
    let nom_ =
      prenom.trim() + " " + nom.trim().split(" ").map(capitalize).join(" ");
    //prenom.trim().split(' ').map(capitalize).join(' ');
    doc.text(nom_, 144, 66, null, null, "center");

    doc.setFont("times", "normal");
    doc.setFontSize(12);
    /*
    let dd_ = new Date(
      dnaiss_.substr(6, 4) +
        "-" +
        dnaiss_.substr(3, 2) +
        "-" +
        dnaiss_.substr(0, 2)
    );
    let dd1 = format(
      new Date(
        dnaiss_.substr(6, 4),
        parseInt(dnaiss_.substr(3, 2)) - 1,
        parseInt(dnaiss_.substr(0, 2)) + 1
      ),
      "dd/MM/yyyy"
    );
    dd_.setDate(dd_.getDate() + 2);
    console.log(dd_);
    console.log("fn Date ==>", dd1);
    */
    //let dnaiss = dd1; //dnaiss_; //"15 Juillet 1978";
    let dnaiss = dnaiss_;
    let lieu = lieu_; //"Port-au-Prince";
    //let ligne1 = `Né(e) le ${dnaiss} à ${lieu}`;
    let datNais = `${dnaiss}`;
    let lieuNais = `${lieu}`;

    //doc.text(ligne1, 60, 100, { charSpace: "0.7" });
    doc.setFont("helvetica", "bold");
    doc.text(datNais, 76, 80, { charSpace: "0.7" });
    doc.text(lieuNais, 128, 80, { charSpace: "0.7" });

    let periode = ""; //" Juillet " + An_;
    if (An_ == "2022") {
      periode = " février " + An_;
    } else {
      periode = " juillet " + An_;
    }

    if (Mois_lib.trim() === "Décembre" || Mois_lib.trim() === "Decembre") {
      periode = " " + Mois_lib.trim() + " " + (parseInt(An_) - 1).toString();
    } else {
      periode = " " + Mois_lib.trim() + " " + An_;
    }

    // periode = " " + Mois_lib.trim() + " " + An_;
    //let periode = " Juillet " + An_;
    //let ligne2 = `a obtenu à la session de ${periode}, le diplôme de fin d'études secondaires`;
    let ligne2 = `${periode}`;
    //doc.text(ligne2, 60, 110, { charSpace: "0.7" });
    doc.text(ligne2, 106, 90, { charSpace: "0.7" });
    // let ligne2 = `a obtenu à la session de ${periode}, le diplôme de fin d'études secondaires`;

    let section = "";
    if (
      session_ === "T" ||
      session_ === "U" ||
      session_ === "V" ||
      session_ === "X"
    ) {
      //let s = Bunexe_service.serie.filter((s) => s.Code_serie == section_)[0];
      section = Section_lib;
    } else {
      section = "Section " + section_.substr(section_.length - 1, 1);
    }

    doc.setFont("helvetica", "bolditalic");
    doc.setFontSize(26);
    //doc.text(section, 144, 130, null, null, "center");
    doc.text(section, 144, 102, null, null, "center");
    let num = matricule; //"0100009876";
    //let numero = `numéro d'enregistrement :${num}`;

    let numero = `${num}`;
    doc.setFont("times", "normal");
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    //doc.text(numero, 60, 144, { charSpace: "0.7" });
    doc.text(numero, 114, 112, { charSpace: "0.7" });
    /*
    let fait_a = `Fait à Port-au-Prince ,`;
    doc.setFont("times", "bold");
    doc.setFontSize(12);
    doc.text(fait_a, 180, 144, { charSpace: "0.7" });
    */

    //let fait_le = `Haïti, le : ${convertToDate(new Date().toISOString())}`;
    let fait_le = ` ${convertToDate(new Date().toISOString())}`;
    doc.setFont("times", "bold");
    doc.setFontSize(14);
    doc.text(fait_le, 192, 120, { charSpace: "0.7" });

    let delegation = "Par délégation du Ministre";
    let direction_generale = "La Direction Génerale";
    doc.setFont("helvetica", "bold");
    doc.text(delegation, 144, 136, null, null, "center");
    doc.text(direction_generale, 144, 142, null, null, "center");

    let dir_bunexe = "Le Directeur du Bureau";
    let bunexe = "National des Examens d'Etat";
    doc.setFont("helvetica", "bold");
    doc.text(dir_bunexe, 80, 172, null, null, "center");
    doc.text(bunexe, 80, 178, null, null, "center");

    // let dir_des = " Nesmy MANIGAT";
    // let des = " Ministre ";
    let dir_des = " Le Directeur";
    let des = " de l'Enseignement Secondaire ";
    doc.setFont("helvetica", "bold");
    doc.text(dir_des, 210, 172, null, null, "center");
    doc.text(des, 210, 178, null, null, "center");

    // Les Bordures
    //  doc.addImage("bordures/bord_haut.jpeg", "jpeg", 1, 0, 300, 15);
    // doc.addImage("bordures/bord_haut.jpeg", "jpeg", 1, 1, 296,7);
    //doc.addImage("bordures/bord_bas.jpeg", "jpeg", 1, 200, 296, 7);
    //    doc.addImage("bordures/bord_bas.jpeg", "jpeg", 4, 195, 297, 15);

    // doc.addImage("bordures/bord_gauche.jpeg", "jpeg", 1, 7, 7, 200);
    // doc.addImage("bordures/bord_droite.jpeg", "jpeg", 289, 7, 7, 200);

    //doc.addImage("bordures/bord_gauche.jpeg", "jpeg", 0.5, 15, 28, 180);
    //doc.addImage("bordures/bord_droite.jpeg", "jpeg", 272.5, 15, 28, 180);

    if (les_documents.includes("legalise seulement")) {
      doc.addImage("menfp_af.png", "png", 30, 130, 20, 20);
      doc.addImage("daj_menfp.png", "png", 30, 153, 40, 6);
    }

    //doc.addImage("menfp_af.jpeg", "jpeg", 260, 100, 20, 20);
    if (les_documents.includes("legalise menfp mae")) {
      doc.addImage("menfp_af.png", "png", 30, 130, 20, 20);
      doc.addImage("daj_menfp.png", "png", 30, 153, 40, 6);

      doc.addImage("mae.jpeg", "jpeg", 250, 130, 20, 20);
      doc.addImage("daj_mae.png", "png", 248, 146, 30, 20);
    }
    // doc.addImage("Directeur_general_menos_jeune.jpg", "jpg", 120, 148, 50, 15);
    doc.addImage("Signature_dirBunexe.png", "PNG", 50, 148, 60, 30);
    //doc.addImage("DirBUNEXE_Renan.jpg", "jpg", 60, 162, 50, 15);
    // doc.addImage("Ministre.jpg", "jpg", 200, 164, 30, 10);
    doc.addImage("DG_Osny.png", "PNG", 127, 118, 50, 28);
    doc.addImage("DES.png", "PNG", 190, 156, 50, 28);
    // experimentation
    let exp_ = "Bunexe e-diplôme en expérimentation";
    doc.setFontSize(16);
    doc.setTextColor("red");
    // doc.setFont("helvetica", "bold");
    doc.setFont("courier", "bolditalic");
    //doc.setFontType("bolditalic");
    //doc.text(exp_, 45, 170, null, 90);

    //doc.output("dataurlnewwindow");
    // doc.save(`bunexe_e_certificat-example-${identifiant}-${nom_}.pdf`);
    // doc.save(`bunexe_e_certificat-C-${identifiant}-${nom_}.pdf`);
    console.log("Screen Size : " + window.screen.availWidth);
    if (window.screen.availWidth < 641) {
      doc.save(`bunexe_e_certificat-C-${identifiant}-${nom_}.pdf`);
    } else {
      const pdfBlob = doc.output("blob");
      const url = URL.createObjectURL(pdfBlob);
      document.getElementById("output").data = url; //URL.createObjectURL(pdfBlob);
      //document.getElementById("output").data = doc.output("datauristring");
      doc.save(`bunexe_e_certificat-C-${identifiant}-${nom_}.pdf`);
      window.currentPdfUrl = url;
    }
  };

  const printPdf2 = (
    img_,
    identifiant,
    nom,
    prenom,
    annee,
    dnaiss_,
    lieu_,
    matricule,
    moy,
    section_,
    session_,
    Section_lib,
    Mois_lib,
  ) => {
    if (window.currentPdfUrl) {
      URL.revokeObjectURL(window.currentPdfUrl);
    }

    // Initialisation en mode Paysage (Landscape)
    const doc = new jsPDF("landscape");
    doc.setFont("times", "normal");

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // Intégrer l'image de fond du diplôme
    doc.addImage(
      "bordures/certificat_bgd.png",
      "PNG",
      0,
      0,
      pageWidth,
      pageHeight,
    );

    doc.setFont("times", "bold"); // Cohérence avec la charte Times New Roman
    let diplome = "DIPLÔME DE FIN D'ETUDES SECONDAIRES";
    doc.text(diplome, 144, 48, null, null, "center");

    let An_ = annee;
    let An__ = "";
    if (["T", "U", "V", "X"].includes(session_)) {
      An__ = "Bac Unique " + annee;
    } else {
      An__ = annee;
    }

    let programme = "SECONDAIRE";
    doc.setFontSize(20);
    doc.setFont("times", "bold");
    doc.text(An__, 40, 144, null, 90);
    doc.text(programme, 260, 142, null, 90);

    // Photo d'identité
    doc.addImage(img_, "png", 34, 44, 28, 28);

    // Nom de l'élève en grand
    doc.setFontSize(30);
    doc.setFont("times", "bold");
    let nom_ =
      prenom.trim() + " " + nom.trim().split(" ").map(capitalize).join(" ");
    doc.text(nom_, 144, 66, null, null, "center");

    // --- CONVERSION ROBUSTE DE LA DATE DE NAISSANCE (ex: 21/06/1996 -> 21 Juin 1996) ---
    let dnaissFormatee = dnaiss_;
    if (dnaiss_ && dnaiss_.includes("/")) {
      const parts = dnaiss_.split("/");
      if (parts.length === 3) {
        const dateObj = new Date(
          parseInt(parts[2]),
          parseInt(parts[1]) - 1,
          parseInt(parts[0]),
        );
        const formatNaiss = new Intl.DateTimeFormat("fr-FR", {
          day: "numeric",
          month: "long",
          year: "numeric",
        }).format(dateObj);
        // Première lettre du mois en majuscule
        dnaissFormatee = formatNaiss.replace(
          /([a-zA-Zùûüéèàç]+)/,
          (match) => match.charAt(0).toUpperCase() + match.slice(1),
        );
      }
    }

    let lieu = lieu_.trim();
    let datNais = `${dnaissFormatee}`;
    let lieuNais = `${lieu}`;

    doc.setFontSize(12);
    doc.setFont("times", "bold");
    doc.text(datNais, 76, 80, { charSpace: "0.7" });
    doc.text(lieuNais, 128, 80, { charSpace: "0.7" });

    // Calcul de la période de session
    let periode = "";
    if (Mois_lib.trim() === "Décembre" || Mois_lib.trim() === "Decembre") {
      periode = " " + Mois_lib.trim() + " " + (parseInt(An_) - 1).toString();
    } else {
      periode = " " + Mois_lib.trim() + " " + An_;
    }

    let ligne2 = `${periode}`;
    doc.text(ligne2, 106, 90, { charSpace: "0.7" });

    // Détermination de la série / section
    let section = "";
    if (["T", "U", "V", "X"].includes(session_)) {
      section = Section_lib;
    } else {
      section = "Section " + section_.substr(section_.length - 1, 1);
    }

    doc.setFont("times", "bolditalic");
    doc.setFontSize(26);
    doc.text(section, 144, 102, null, null, "center");

    // Numéro de matricule
    let numero = `${matricule}`;
    doc.setFont("times", "bold");
    doc.setFontSize(14);
    doc.text(numero, 114, 112, { charSpace: "0.7" });

    // Date de signature du document (Fait le...)
    let fait_le = ` ${convertToDate(new Date().toISOString())}`;
    doc.setFont("times", "bold");
    doc.setFontSize(14);
    doc.text(fait_le, 192, 120, { charSpace: "0.7" });

    // --- BLOC DES SIGNATAIRES AUTORISÉS ---
    let delegation = "Par délégation du Ministre";
    let direction_generale = "La Direction Génerale";
    doc.setFont("times", "bold");
    doc.text(delegation, 144, 136, null, null, "center");
    doc.text(direction_generale, 144, 142, null, null, "center");

    let dir_bunexe = "Le Directeur du Bureau";
    let bunexe = "National des Examens d'Etat";
    doc.text(dir_bunexe, 80, 172, null, null, "center");
    doc.text(bunexe, 80, 178, null, null, "center");

    let dir_des = " Le Directeur";
    let des = " de l'Enseignement Secondaire ";
    doc.text(dir_des, 210, 172, null, null, "center");
    doc.text(des, 210, 178, null, null, "center");

    // --- AJOUT DES TIMBRES ET VISAS DE LÉGALISATION ---
    if (typeof les_documents !== "undefined") {
      if (les_documents.includes("legalise seulement")) {
        doc.addImage("menfp_af.png", "png", 30, 130, 20, 20);
        doc.addImage("daj_menfp.png", "png", 30, 153, 40, 6);
      }

      if (les_documents.includes("legalise menfp mae")) {
        doc.addImage("menfp_af.png", "png", 30, 130, 20, 20);
        doc.addImage("daj_menfp.png", "png", 30, 153, 40, 6);
        doc.addImage("mae.jpeg", "jpeg", 250, 130, 20, 20);
        doc.addImage("daj_mae.png", "png", 248, 146, 30, 20);
      }
    }

    // --- TRAITEMENT DES SIGNATURES MANUSCRITES GRAPHINES ---
    doc.addImage("Signature_dirBunexe.png", "PNG", 50, 148, 60, 30);
    doc.addImage("DG_Osny.png", "PNG", 127, 118, 50, 28);
    doc.addImage("DES.png", "PNG", 190, 156, 50, 28);

    // Mention d'expérimentation
    let exp_ = "Bunexe e-diplôme en expérimentation";
    doc.setFontSize(16);
    doc.setTextColor("red");
    doc.setFont("courier", "bolditalic");

    // --- GESTION DU FLUX DE SORTIE ET AFFICHAGE ---
    if (window.screen.availWidth < 641) {
      doc.save(`bunexe_e_certificat-C-${identifiant}-${nom_}.pdf`);
    } else {
      const pdfBlob = doc.output("blob");
      const url = URL.createObjectURL(pdfBlob);
      document.getElementById("output").data = url;
      doc.save(`bunexe_e_certificat-C-${identifiant}-${nom_}.pdf`);
      window.currentPdfUrl = url;
    }
  };
  const printPdf3 = (
    img_,
    identifiant,
    nom,
    prenom,
    annee,
    dnaiss_,
    lieu_,
    matricule,
    moy,
    section_,
    session_,
    Section_lib,
    Mois_lib,
  ) => {
    if (window.currentPdfUrl) {
      URL.revokeObjectURL(window.currentPdfUrl);
    }

    // Initialisation en mode Paysage (Landscape)
    const doc = new jsPDF("landscape");
    doc.setFont("times", "normal");

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // Intégrer l'image de fond du diplôme
    doc.addImage(
      "bordures/certificat_bgd.png",
      "PNG",
      0,
      0,
      pageWidth,
      pageHeight,
    );

    doc.setFont("times", "bold");
    let diplome = "DIPLÔME DE FIN D'ETUDES SECONDAIRES";
    doc.text(diplome, 144, 48, null, null, "center");

    let An_ = annee;
    let An__ = "";
    if (["T", "U", "V", "X"].includes(session_)) {
      An__ = "Bac Unique " + annee;
    } else {
      An__ = annee;
    }

    let programme = "SECONDAIRE";
    doc.setFontSize(20);
    doc.setFont("times", "bold");
    doc.text(An__, 40, 144, null, 90);
    doc.text(programme, 260, 142, null, 90);

    // Photo d'identité
    doc.addImage(img_, "png", 34, 44, 28, 28);

    // Nom de l'élève en grand
    doc.setFontSize(30);
    doc.setFont("times", "bold");
    let nom_ =
      prenom.trim() + " " + nom.trim().split(" ").map(capitalize).join(" ");
    doc.text(nom_, 144, 66, null, null, "center");

    // --- CONVERSION ROBUSTE DE LA DATE DE NAISSANCE (ex: 21/06/1996 -> 21 Juin 1996) ---
    let dnaissFormatee = dnaiss_;
    if (dnaiss_ && dnaiss_.includes("/")) {
      const parts = dnaiss_.split("/");
      if (parts.length === 3) {
        const dateObj = new Date(
          parseInt(parts[2]),
          parseInt(parts[1]) - 1,
          parseInt(parts[0]),
        );
        const formatNaiss = new Intl.DateTimeFormat("fr-FR", {
          day: "numeric",
          month: "long",
          year: "numeric",
        }).format(dateObj);
        dnaissFormatee = formatNaiss.replace(
          /([a-zA-Zùûüéèàç]+)/,
          (match) => match.charAt(0).toUpperCase() + match.slice(1),
        );
      }
    }

    let lieu = lieu_.trim();
    let datNais = `${dnaissFormatee}`;
    let lieuNais = `${lieu}`;

    doc.setFontSize(12);
    doc.setFont("times", "bold");
    doc.text(datNais, 76, 80, { charSpace: "0.7" });
    doc.text(lieuNais, 128, 80, { charSpace: "0.7" });

    // Calcul de la période de session
    let periode = "";
    if (Mois_lib.trim() === "Décembre" || Mois_lib.trim() === "Decembre") {
      periode = " " + Mois_lib.trim() + " " + (parseInt(An_) - 1).toString();
    } else {
      periode = " " + Mois_lib.trim() + " " + An_;
    }

    let ligne2 = `${periode}`;
    doc.text(ligne2, 106, 90, { charSpace: "0.7" });

    // Détermination de la série / section
    let section = "";
    if (["T", "U", "V", "X"].includes(session_)) {
      section = Section_lib;
    } else {
      section = "Section " + section_.substr(section_.length - 1, 1);
    }

    doc.setFont("times", "bolditalic");
    doc.setFontSize(26);
    doc.text(section, 144, 102, null, null, "center");

    // Numéro de matricule
    let numero = `${matricule}`;
    doc.setFont("times", "bold");
    doc.setFontSize(14);
    doc.text(numero, 114, 112, { charSpace: "0.7" });

    // --- CONVERSION DU CHAMP "FAIT LE" EN TEXTE COMPLET (ex: 19 Juillet 2026) ---
    const aujourdHui = new Date();
    const formatFaitLe = new Intl.DateTimeFormat("fr-FR", {
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(aujourdHui);
    // Première lettre du mois en majuscule pour correspondre exactement à la date de naissance
    const faitLeFormate = formatFaitLe.replace(
      /([a-zA-Zùûüéèàç]+)/,
      (match) => match.charAt(0).toUpperCase() + match.slice(1),
    );

    let fait_le = ` ${faitLeFormate}`;
    doc.setFont("times", "bold");
    doc.setFontSize(14);
    doc.text(fait_le, 192, 120, { charSpace: "0.7" });

    // --- BLOC DES SIGNATAIRES AUTORISÉS ---
    let delegation = "Par délégation du Ministre";
    let direction_generale = "La Direction Génerale";
    doc.setFont("times", "bold");
    doc.text(delegation, 144, 136, null, null, "center");
    doc.text(direction_generale, 144, 142, null, null, "center");

    let dir_bunexe = "Le Directeur du Bureau";
    let bunexe = "National des Examens d'Etat";
    doc.text(dir_bunexe, 80, 172, null, null, "center");
    doc.text(bunexe, 80, 178, null, null, "center");

    let dir_des = " Le Directeur";
    let des = " de l'Enseignement Secondaire ";
    doc.text(dir_des, 210, 172, null, null, "center");
    doc.text(des, 210, 178, null, null, "center");

    // --- AJOUT DES TIMBRES ET VISAS DE LÉGALISATION ---
    if (typeof les_documents !== "undefined") {
      if (les_documents.includes("legalise seulement")) {
        doc.addImage("menfp_af.png", "png", 30, 130, 20, 20);
        doc.addImage("daj_menfp.png", "png", 30, 153, 40, 6);
      }

      if (les_documents.includes("legalise menfp mae")) {
        doc.addImage("menfp_af.png", "png", 30, 130, 20, 20);
        doc.addImage("daj_menfp.png", "png", 30, 153, 40, 6);
        doc.addImage("mae.jpeg", "jpeg", 250, 130, 20, 20);
        doc.addImage("daj_mae.png", "png", 248, 146, 30, 20);
      }
    }

    // --- TRAITEMENT DES SIGNATURES MANUSCRITES ---
    doc.addImage("Signature_dirBunexe.png", "PNG", 50, 148, 60, 30);
    doc.addImage("DG_Osny.png", "PNG", 127, 118, 50, 28);
    doc.addImage("DES.png", "PNG", 190, 156, 50, 28);

    // Mention d'expérimentation
    let exp_ = "Bunexe e-diplôme en expérimentation";
    doc.setFontSize(16);
    doc.setTextColor("red");
    doc.setFont("courier", "bolditalic");

    // --- GESTION DU FLUX DE SORTIE ET TÉLÉCHARGEMENT ---
    if (window.screen.availWidth < 641) {
      doc.save(`bunexe_e_certificat-C-${identifiant}-${nom_}.pdf`);
    } else {
      const pdfBlob = doc.output("blob");
      const url = URL.createObjectURL(pdfBlob);
      document.getElementById("output").data = url;
      doc.save(`bunexe_e_certificat-C-${identifiant}-${nom_}.pdf`);
      window.currentPdfUrl = url;
    }
  };

  const printPdf = (
    img_,
    identifiant,
    nom,
    prenom,
    annee,
    dnaiss_,
    lieu_,
    matricule,
    moy,
    section_,
    session_,
    Section_lib,
    Mois_lib,
  ) => {
    if (window.currentPdfUrl) {
      URL.revokeObjectURL(window.currentPdfUrl);
    }

    // Initialisation en mode Paysage (Landscape)
    const doc = new jsPDF("landscape");
    doc.setFont("times", "normal");

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // Intégrer l'image de fond du diplôme
    doc.addImage(
      "bordures/certificat_bgd.png",
      "PNG",
      0,
      0,
      pageWidth,
      pageHeight,
    );

    doc.setFont("times", "bold");
    let diplome = "DIPLÔME DE FIN D'ETUDES SECONDAIRES";
    doc.text(diplome, 144, 48, null, null, "center");

    let An_ = annee;
    let An__ = "";
    let anneeYPosition = 144; // Position par défaut pour "Bac Unique XXXX"

    if (["T", "U", "V", "X"].includes(session_)) {
      An__ = "Bac Unique " + annee;
      anneeYPosition = 144; // Garde l'alignement bas pour les longues chaînes
    } else {
      An__ = annee;
      anneeYPosition = 126; // Remonte l'année (ex: 1993) pour la recentrer parfaitement dans le bloc vertical
    }

    let programme = "SECONDAIRE";
    doc.setFontSize(20);
    doc.setFont("times", "bold");
    doc.text(An__, 40, anneeYPosition, null, 90); // Utilisation de la position dynamique
    doc.text(programme, 260, 142, null, 90);

    // Photo d'identité
    doc.addImage(img_, "png", 34, 44, 28, 28);

    // Nom de l'élève en grand
    doc.setFontSize(30);
    doc.setFont("times", "bold");
    let nom_ =
      prenom.trim() + " " + nom.trim().split(" ").map(capitalize).join(" ");
    doc.text(nom_, 144, 66, null, null, "center");

    // --- CONVERSION ROBUSTE DE LA DATE DE NAISSANCE (ex: 21/06/1996 -> 21 Juin 1996) ---
    let dnaissFormatee = dnaiss_;
    if (dnaiss_ && dnaiss_.includes("/")) {
      const parts = dnaiss_.split("/");
      if (parts.length === 3) {
        const dateObj = new Date(
          parseInt(parts[2]),
          parseInt(parts[1]) - 1,
          parseInt(parts[0]),
        );
        const formatNaiss = new Intl.DateTimeFormat("fr-FR", {
          day: "numeric",
          month: "long",
          year: "numeric",
        }).format(dateObj);
        dnaissFormatee = formatNaiss.replace(
          /([a-zA-Zùûüéèàç]+)/,
          (match) => match.charAt(0).toUpperCase() + match.slice(1),
        );
      }
    }

    let lieu = lieu_.trim();
    let datNais = `${dnaissFormatee}`;
    let lieuNais = `${lieu}`;

    doc.setFontSize(12);
    doc.setFont("times", "bold");
    doc.text(datNais, 76, 80, { charSpace: "0.7" });
    doc.text(lieuNais, 128, 80, { charSpace: "0.7" });

    // Calcul de la période de session
    let periode = "";
    if (Mois_lib.trim() === "Décembre" || Mois_lib.trim() === "Decembre") {
      periode = " " + Mois_lib.trim() + " " + (parseInt(An_) - 1).toString();
    } else {
      periode = " " + Mois_lib.trim() + " " + An_;
    }

    let ligne2 = `${periode}`;
    doc.text(ligne2, 106, 90, { charSpace: "0.7" });

    // Détermination de la série / section
    let section = "";
    if (["T", "U", "V", "X"].includes(session_)) {
      section = Section_lib;
    } else {
      section = "Section " + section_.substr(section_.length - 1, 1);
    }

    doc.setFont("times", "bolditalic");
    doc.setFontSize(26);
    doc.text(section, 144, 102, null, null, "center");

    // Numéro de matricule
    let numero = `${matricule}`;
    doc.setFont("times", "bold");
    doc.setFontSize(14);
    doc.text(numero, 114, 112, { charSpace: "0.7" });

    // --- CONVERSION DU CHAMP "FAIT LE" EN TEXTE COMPLET (ex: 19 Juillet 2026) ---
    const aujourdHui = new Date();
    const formatFaitLe = new Intl.DateTimeFormat("fr-FR", {
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(aujourdHui);
    const faitLeFormate = formatFaitLe.replace(
      /([a-zA-Zùûüéèàç]+)/,
      (match) => match.charAt(0).toUpperCase() + match.slice(1),
    );

    let fait_le = ` ${faitLeFormate}`;
    doc.setFont("times", "bold");
    doc.setFontSize(14);
    doc.text(fait_le, 192, 120, { charSpace: "0.7" });

    // --- BLOC DES SIGNATAIRES AUTORISÉS ---
    let delegation = "Par délégation du Ministre";
    let direction_generale = "La Direction Génerale";
    doc.setFont("times", "bold");
    doc.text(delegation, 144, 136, null, null, "center");
    doc.text(direction_generale, 144, 142, null, null, "center");

    let dir_bunexe = "Le Directeur du Bureau";
    let bunexe = "National des Examens d'Etat";
    doc.text(dir_bunexe, 80, 172, null, null, "center");
    doc.text(bunexe, 80, 178, null, null, "center");

    let dir_des = " Le Directeur";
    let des = " de l'Enseignement Secondaire ";
    doc.text(dir_des, 210, 172, null, null, "center");
    doc.text(des, 210, 178, null, null, "center");

    // --- AJOUT DES TIMBRES ET VISAS DE LÉGALISATION ---
    if (typeof les_documents !== "undefined") {
      if (les_documents.includes("legalise seulement")) {
        doc.addImage("menfp_af.png", "png", 30, 130, 20, 20);
        doc.addImage("daj_menfp.png", "png", 30, 153, 40, 6);
      }

      if (les_documents.includes("legalise menfp mae")) {
        doc.addImage("menfp_af.png", "png", 30, 130, 20, 20);
        doc.addImage("daj_menfp.png", "png", 30, 153, 40, 6);
        doc.addImage("mae.jpeg", "jpeg", 250, 130, 20, 20);
        doc.addImage("daj_mae.png", "png", 248, 146, 30, 20);
      }
    }

    // --- TRAITEMENT DES SIGNATURES MANUSCRITES ---
    doc.addImage("Signature_dirBunexe.png", "PNG", 50, 148, 60, 30);
    doc.addImage("DG_Osny.png", "PNG", 127, 118, 50, 28);
    doc.addImage("DES.png", "PNG", 190, 156, 50, 28);

    // Mention d'expérimentation
    let exp_ = "Bunexe e-diplôme en expérimentation";
    doc.setFontSize(16);
    doc.setTextColor("red");
    doc.setFont("courier", "bolditalic");

    // --- GESTION DU FLUX DE SORTIE ET TÉLÉCHARGEMENT ---
    if (window.screen.availWidth < 641) {
      doc.save(`bunexe_e_certificat-C-${identifiant}-${nom_}.pdf`);
    } else {
      const pdfBlob = doc.output("blob");
      const url = URL.createObjectURL(pdfBlob);
      document.getElementById("output").data = url;
      doc.save(`bunexe_e_certificat-C-${identifiant}-${nom_}.pdf`);
      window.currentPdfUrl = url;
    }
  };
  // With async/await
  const generateQR = async (
    type,
    identifiant,
    nom,
    prenom,
    annee,
    dnaiss,
    lieu,
    matricule,
    moy,
    section,
    session,
    Section_lib,
    Mois_lib,
    sexe,
    notes,
    TotCoef,
  ) => {
    // let text = `${identifiant} , ${nom} ${prenom}, ${annee},${dnaiss},${lieu}, ${matricule}, ${moy}`;
    let text = `${identifiant}`;
    try {
      const options = {
        color: {
          dark: "#000000", // Foreground color (Black)
          light: "#00000000", // Background color (Transparent Hex - RGBA)
        },
      };
      let u = await QRCode.toDataURL(text, options);
      //console.log(text);
      // console.log(await QRCode.toDataURL(text));
      setImageurl(u);
      // console.log(nom, prenom, annee, matricule, moy);
      if (type == "C") {
        printPdf(
          u,
          identifiant,
          nom,
          prenom,
          annee,
          dnaiss,
          lieu,
          matricule,
          moy,
          section,
          session,
          Section_lib,
          Mois_lib,
        );
      } else {
        printReleve(
          u,
          identifiant,
          nom,
          prenom,
          annee,
          dnaiss,
          lieu,
          matricule,
          moy,
          section,
          session,
          Section_lib,
          sexe,
          notes,
          TotCoef,
          Mois_lib,
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    setResultat([Info_personnelle]);
    let les_docs = String(valeurSelectionnee)
      .toLowerCase()
      .replaceAll("_", " ");

    setLesDocuments(les_docs);
  }, []);

  // let les_documents = String(valeurSelectionnee).replaceAll("_"," ")

  // const Rechercher = async () => {
  //   // let url_ = "http://localhost:8086/api";
  //   let sc = window.screen.availWidth;
  //   console.log("############   Screen Size    ###############");
  //   console.log(sc);
  //   console.log("############  Fin Screen Size    ###############");

  //   try {
  //     fetch(url_ + `/dossier/an_section/${matricule}`)
  //       .then((response) => response.json())
  //       .then((data) => {
  //         if (data.data.length > 0) {
  //           console.log(data.data);
  //           setResultat(data.data);
  //         } else
  //           toast.error(
  //             "Information non - trouvée, Veuiller consulter le numéro d'ordre du candidat",
  //             {
  //               position: toast.POSITION.TOP_RIGHT,
  //             }
  //           );
  //       })
  //       .catch((err) => console.log(err));
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  //col-md-6 offset-md-3 col-lg-6 offset-lg-3
  return (
    <div className="container-fluid">
      <div className="row d-flex justify-content-center">
        <div className="col-sm-12 ">
          <div class="card">
            <div class="card-body">
              {resultat &&
                resultat[0] != null &&
                resultat.map((r, index) => (
                  <div key={index} className="d-flex justify-content-center">
                    <p className="font-weight-bold font-italic">
                      {/* {` ${r.nom} ${r.prenom},né(e) le ${r.dateNaiss} en ${
                    r.Section_lib
                  } a obtenu la moyenne ${parseFloat(r.Moy).toFixed(
                    2
                  )} ;Mention :${
                    r.Admis == "O" ? " Admis(e)" : " Echoué(e) "
                  } `}
                  {` documents selctionne :  ==> ${les_documents}`}
                  <p> */}
                      {r.Admis == "O" &&
                        les_documents.includes("certificat") && (
                          <button
                            type="button"
                            class="btn btn-outline-warning btn-sm"
                            onClick={() =>
                              generateQR(
                                "C",
                                r.Identifiant,
                                r.nom,
                                r.prenom,
                                r.Annee,
                                r.dateNaiss,
                                r.lieu,
                                r.Matricule,
                                parseFloat(r.Moy).toFixed(2),
                                r.Section,
                                r.Session,
                                r.Section_lib,
                                r.Mois_Lib,
                                r.sexe,
                                r.Session === "E"
                                  ? r.extraordinaire
                                  : r.ordinaire,
                                r.TotCoef,
                              )
                            }
                          >
                            Imprimer e-diplôme
                          </button>
                        )}

                      {`  `}
                      {les_documents.includes("releve") && (
                        <button
                          type="button"
                          class="btn btn-outline-warning btn-sm mr-3"
                          onClick={() =>
                            generateQR(
                              "R",
                              r.Identifiant,
                              r.nom,
                              r.prenom,
                              r.Annee,
                              r.dateNaiss,
                              r.lieu,
                              r.Matricule,
                              parseFloat(r.Moy).toFixed(2),
                              r.Section,
                              r.Session,
                              r.Section_lib,
                              r.Mois_Lib,
                              r.sexe,
                              r.Session === "E"
                                ? r.extraordinaire
                                : r.ordinaire,
                              r.TotCoef,
                            )
                          }
                        >
                          Imprimer e-relevé
                        </button>
                      )}
                      {/* </p> */}
                    </p>

                    {/* <div className="d-flex justify-content-between px-4">
                  {r.Admis == "O" && (
                    <button
                      type="button"
                      class="btn btn-outline-success btn-sm"
                      onClick={() =>
                        generateQR(
                          "C",
                          r.Identifiant,
                          r.nom,
                          r.prenom,
                          r.Annee,
                          r.dateNaiss,
                          r.lieu,
                          r.Matricule,
                          parseFloat(r.Moy).toFixed(2),
                          r.Section,
                          r.Session,
                          r.Section_lib,
                          r.sexe,
                          r.Session === "E" ? r.extraordinaire : r.ordinaire
                        )
                      }
                    >
                      e-diplôme
                    </button>
                  )}
                  <button
                    type="button"
                    class="btn btn-outline-success btn-sm mr-3"
                    onClick={() =>
                      generateQR(
                        "R",
                        r.Identifiant,
                        r.nom,
                        r.prenom,
                        r.Annee,
                        r.dateNaiss,
                        r.lieu,
                        r.Matricule,
                        parseFloat(r.Moy).toFixed(2),
                        r.Section,
                        r.Session,
                        r.Section_lib,
                        r.sexe,
                        r.Session === "E" ? r.extraordinaire : r.ordinaire
                      )
                    }
                  >
                    e-relevé
                  </button>
                </div> */}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <object
            id="output"
            type="application/pdf"
            width="100%"
            height="740px"
          >
            <p>
              {/* <a href={`${mysrc}`} id="download-link">
             
            </a> */}
              {/* .{`La Source est :${mysrc}`} */}
            </p>
          </object>
        </div>
      </div>

      {name}
      {/* <button onClick={() => generateQR(name)}> Generate</button>
    <br />
    {imageurl ? <img width="200" height="200" src={imageurl} /> : ""} */}

      {/* <ToastContainer /> */}
    </div>

    // <div className="container-fluid">
    //   <div className="row d-flex justify-content-center">
    //     <div className="col-sm-12 ">
    //       <div class="card">
    //         <div class="card-body">
    //           {resultat &&
    //             resultat[0] != null &&
    //             resultat.map((r, index) => (
    //               <div key={index}>
    //                 <p className="font-weight-bold font-italic">
    //                   {/* {` ${r.nom} ${r.prenom},né(e) le ${r.dateNaiss} en ${
    //                   r.Section_lib
    //                 } a obtenu la moyenne ${parseFloat(r.Moy).toFixed(
    //                   2
    //                 )} ;Mention :${
    //                   r.Admis == "O" ? " Admis(e)" : " Echoué(e) "
    //                 } `}
    //                 {` documents selctionne :  ==> ${les_documents}`}
    //                 <p> */}
    //                   {les_documents.includes("releve") && (
    //                     <button
    //                       type="button"
    //                       class="btn btn-outline-warning btn-sm mr-3"
    //                       onClick={() =>
    //                         generateQR(
    //                           "R",
    //                           r.Identifiant,
    //                           r.nom,
    //                           r.prenom,
    //                           r.Annee,
    //                           r.dateNaiss,
    //                           r.lieu,
    //                           r.Matricule,
    //                           parseFloat(r.Moy).toFixed(2),
    //                           r.Section,
    //                           r.Session,
    //                           r.Section_lib,
    //                           r.sexe,
    //                           r.Session === "E"
    //                             ? r.extraordinaire
    //                             : r.ordinaire,
    //                           r.TotCoef
    //                         )
    //                       }
    //                     >
    //                       e-relevé
    //                     </button>
    //                   )}
    //                   {`  `}
    //                   {r.Admis == "O" && les_documents.includes("certificat") && (
    //                     <button
    //                       type="button"
    //                       class="btn btn-outline-warning btn-sm"
    //                       onClick={() =>
    //                         generateQR(
    //                           "C",
    //                           r.Identifiant,
    //                           r.nom,
    //                           r.prenom,
    //                           r.Annee,
    //                           r.dateNaiss,
    //                           r.lieu,
    //                           r.Matricule,
    //                           parseFloat(r.Moy).toFixed(2),
    //                           r.Section,
    //                           r.Session,
    //                           r.Section_lib,
    //                           r.sexe,
    //                           r.Session === "E"
    //                             ? r.extraordinaire
    //                             : r.ordinaire,
    //                           r.TotCoef
    //                         )
    //                       }
    //                     >
    //                       e-diplôme
    //                     </button>
    //                   )}

    //                   {/* </p> */}
    //                 </p>

    //                 {/* <div className="d-flex justify-content-between px-4">
    //                 {r.Admis == "O" && (
    //                   <button
    //                     type="button"
    //                     class="btn btn-outline-success btn-sm"
    //                     onClick={() =>
    //                       generateQR(
    //                         "C",
    //                         r.Identifiant,
    //                         r.nom,
    //                         r.prenom,
    //                         r.Annee,
    //                         r.dateNaiss,
    //                         r.lieu,
    //                         r.Matricule,
    //                         parseFloat(r.Moy).toFixed(2),
    //                         r.Section,
    //                         r.Session,
    //                         r.Section_lib,
    //                         r.sexe,
    //                         r.Session === "E" ? r.extraordinaire : r.ordinaire
    //                       )
    //                     }
    //                   >
    //                     e-diplôme
    //                   </button>
    //                 )}
    //                 <button
    //                   type="button"
    //                   class="btn btn-outline-success btn-sm mr-3"
    //                   onClick={() =>
    //                     generateQR(
    //                       "R",
    //                       r.Identifiant,
    //                       r.nom,
    //                       r.prenom,
    //                       r.Annee,
    //                       r.dateNaiss,
    //                       r.lieu,
    //                       r.Matricule,
    //                       parseFloat(r.Moy).toFixed(2),
    //                       r.Section,
    //                       r.Session,
    //                       r.Section_lib,
    //                       r.sexe,
    //                       r.Session === "E" ? r.extraordinaire : r.ordinaire
    //                     )
    //                   }
    //                 >
    //                   e-relevé
    //                 </button>
    //               </div> */}
    //               </div>
    //             ))}
    //         </div>
    //       </div>
    //     </div>
    //   </div>

    //   <div className="row">
    //     <div className="col-sm-12 col-md-12 col-lg-12">
    //       <object
    //         id="output"
    //         type="application/pdf"
    //         width="100%"
    //         height="740px"
    //       >
    //         <p>
    //           {/* <a href={`${mysrc}`} id="download-link">

    //           </a> */}
    //           {/* .{`La Source est :${mysrc}`} */}
    //         </p>
    //       </object>
    //     </div>
    //   </div>

    //   {name}
    //   {/* <button onClick={() => generateQR(name)}> Generate</button>
    //   <br />
    //   {imageurl ? <img width="200" height="200" src={imageurl} /> : ""} */}

    //   {/* <ToastContainer /> */}
    // </div>
  );
};

export default Ediplome;
